import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Grid,
  Card,
  CardContent,
  Avatar,
  IconButton,
  Divider,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Autocomplete
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { TransButton } from '../../common/TransButton';
import { FirebaseImageUpload } from '../../common/FirebaseImageUpload';
import Axios from "axios";
import { Config } from "../../../utils/commonFuctions/Token";
import { base_url } from '../../backendurl/url';
import ModalPopUp from '../../common/TransForm/ModalPopUp';
import { Notification } from '../../common/Notification';


// const EditLeagueModal = ({ open, onClose, onSave, leagueData, gamesData, onRefreshLeagues }) => {
//   const [gameSelection, setGameSelection] = useState('');
//   const [leagueName, setLeagueName] = useState('');
//   const [leagueNameType, setLeagueNameType] = useState('text'); // 'text' or 'dropdown'
//   const [availableLeagues, setAvailableLeagues] = useState([]);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreview, setLogoPreview] = useState('');
//   const [isUploading, setIsUploading] = useState(false);
//   const [isLoadingLeagues, setIsLoadingLeagues] = useState(false);
//   const [uploadError, setUploadError] = useState('');

//   // Initialize form with existing league data when modal opens
//   // useEffect(() => {
//   //   if (open && leagueData) {
//   //     // Find the game ID for this league
//   //     const gameId = gamesData.find(game => 
//   //       game.game_name === leagueData.game || game.id === leagueData.game_id
//   //     )?.id || '';
//   //     console.log(leagueData, "leagueData88");
//   //     console.log(gamesData, "gamesData99")
//   //     setGameSelection(gameId);
//   //     setLeagueName(leagueData.name || '');
//   //     setLogoPreview(leagueData.logo || '');
//   //     setLogoFile(null);
//   //     setIsUploading(false);
//   //     setIsLoadingLeagues(false);
//   //     setUploadError('');
//   //   }
//   // }, [open, leagueData, gamesData]);

//   useEffect(() => {
//     if (open && leagueData) {
//       const gameId = gamesData.find(game => game.id === leagueData.game)?.id || '';
//       const selectedGame = gamesData.find(game => game.id === gameId);

//       setGameSelection(gameId);
//       setLeagueName(leagueData.name || '');
//       setLogoPreview(leagueData.logo_url || '');
//       setLogoFile(null);
//       setIsUploading(false);
//       setIsLoadingLeagues(false);
//       setUploadError('');

//       if (selectedGame?.game_name?.toLowerCase() === 'football') {
//         setLeagueNameType('dropdown');
//         fetchAvailableLeagues();
//       } else {
//         setLeagueNameType('text');
//         setAvailableLeagues([]);
//       }
//     }
//   }, [open, leagueData, gamesData]);


//   // Get selected game object to access game name
//   const selectedGameObj = gamesData.find(game => game.id === gameSelection);

//   // Fetch leagues when game changes
//   useEffect(() => {
//     if (selectedGameObj && selectedGameObj.game_name.toLowerCase() === 'football') {
//       fetchAvailableLeagues();
//       setLeagueNameType('dropdown');
//     } else {
//       setLeagueNameType('text');
//       setAvailableLeagues([]);
//     }
//     // Don't reset league name when editing - keep existing value
//   }, [gameSelection, selectedGameObj]);

//   const fetchAvailableLeagues = async () => {
//     setIsLoadingLeagues(true);
//     try {
//       const response = await Axios.get(`${base_url}/api/pot/leagues`, Config);
//       let leaquename = response?.data?.data.map((item) => {
//         return {
//           ...item,
//           id: item?.league_id,
//           name: `${item?.league_name} - ${item?.country}`,
//         }
//       });
//       setAvailableLeagues(leaquename);

//     } catch (error) {
//       console.error('Error fetching leagues:', error);
//       setUploadError('Failed to load leagues. Please try again.');
//     } finally {
//       setIsLoadingLeagues(false);
//     }
//   };

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.startsWith('image/')) {
//         setUploadError('Please select an image file');
//         return;
//       }

//       // Validate file size (10MB limit)
//       if (file.size > 10 * 1024 * 1024) {
//         setUploadError('File size should be less than 10MB');
//         return;
//       }

//       setUploadError('');
//       setLogoFile(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setLogoPreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleUpdate = async (shouldRefresh = false) => {
//     if (!gameSelection) {
//       setUploadError('Please select a game');
//       return;
//     }

//     if (!leagueName.trim()) {
//       setUploadError('League name is required');
//       return;
//     }

//     setIsUploading(true);
//     setUploadError('');

//     try {
//       let firebaseImageUrl = '';

//       // Upload new image to Firebase if file is selected
//       if (logoFile) {
//         const uploadResult = await FirebaseImageUpload(logoFile);
//         // Remove query parameters from Firebase URL
//         firebaseImageUrl = uploadResult.split('&')[0];
//       } else {
//         // Keep existing logo if no new file uploaded
//         firebaseImageUrl = leagueData.logo || leagueData.logo_url || '';
//       }

//       // Prepare payload for update
//       const updatePayload = {
//         name: leagueName.trim(),
//         game_id: gameSelection,
//         is_system_league: leagueData.type === 'API' ? true : false,
//         is_active: leagueData.isSelected || false,
//         logo_url: firebaseImageUrl
//       };

//       //console.log('League update payload:', updatePayload);

//       // Call API to update league
//       const response = await Axios.put(
//         `${base_url}/api/pot/preferredleagues/${leagueData.id}/`,
//         updatePayload,
//         Config
//       );

//       //console.log('League update response:', response);

//       if (response.data) {
//         // Create updated league object for UI update
//         const updatedLeague = {
//           ...leagueData,
//           id: leagueData.id,
//           name: leagueName.trim(),
//           game_id: gameSelection,
//           logo: firebaseImageUrl,
//           shortName: leagueName.trim().substring(0, 3).toUpperCase(),
//           ...response.data // Include any additional data from API response
//         };

//         //console.log('Updated league object:', updatedLeague);

//         onSave(updatedLeague);
//         handleCancel();
//         console.log('League updated successfully:', response.data);
//         if (shouldRefresh && onRefreshLeagues) {
//           onRefreshLeagues();
//         }
//       }
//     } catch (error) {
//       console.error('Error updating league:', error);
//       setUploadError('Failed to update league. Please try again.');
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handleCancel = () => {
//     setGameSelection('');
//     setLeagueName('');
//     setLeagueNameType('text');
//     setAvailableLeagues([]);
//     setLogoFile(null);
//     setLogoPreview('');
//     setIsUploading(false);
//     setIsLoadingLeagues(false);
//     setUploadError('');
//     onClose();
//   };

//   const isFormValid = gameSelection && leagueName.trim() && !isUploading && !isLoadingLeagues;

//   return (
//     <Dialog
//       open={open}
//       onClose={handleCancel}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: '12px',
//           maxWidth: '500px'
//         }
//       }}
//     >
//       <DialogTitle sx={{ p: 0 }}>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             p: 3,
//             borderBottom: '1px solid #E5E7EB'
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               fontSize: '18px',
//               color: '#1F2937'
//             }}
//           >
//             Edit league
//           </Typography>
//           <IconButton
//             onClick={handleCancel}
//             disabled={isUploading}
//             sx={{
//               color: '#6B7280',
//               '&:hover': { backgroundColor: '#F3F4F6' }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         <Stack spacing={3}>
//           {/* Step 1: Game Selection Field */}
//           <Box>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#374151',
//                 fontWeight: 500,
//                 mb: 1
//               }}
//             >
//               Which sport does it belong to *
//             </Typography>
//             <FormControl fullWidth>
//               <Select
//                 value={gameSelection}
//                 onChange={(e) => setGameSelection(e.target.value)}
//                 displayEmpty
//                 disabled={isUploading}
//                 MenuProps={{
//                   PaperProps: {
//                     style: {
//                       maxHeight: 200,
//                     },
//                   },
//                   anchorOrigin: {
//                     vertical: "bottom",
//                     horizontal: "left"
//                   },
//                   transformOrigin: {
//                     vertical: "top",
//                     horizontal: "left"
//                   },
//                   getContentAnchorEl: null,
//                 }}
//                 sx={{
//                   borderRadius: '8px',
//                   '& .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#D1D5DB',
//                   },
//                   '&:hover .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#9CA3AF',
//                   },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#3C50E0',
//                   },
//                 }}
//               >
//                 <MenuItem value="" disabled>
//                   <Typography sx={{ color: '#9CA3AF' }}>Select a game</Typography>
//                 </MenuItem>
//                 {gamesData.map((game) => (
//                   <MenuItem key={game.id} value={game.id}>
//                     {game.game_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>


//           {gameSelection && (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Name *
//               </Typography>

//               {leagueNameType === 'dropdown' ? (
//                 // Dropdown for Football
//                 <FormControl fullWidth>
//                   <Select
//                     value={leagueName}
//                     onChange={(e) => setLeagueName(e.target.value)}
//                     displayEmpty
//                     disabled={isUploading || isLoadingLeagues}
//                     MenuProps={{
//                       PaperProps: {
//                         style: {
//                           maxHeight: 200,
//                         },
//                       },
//                       anchorOrigin: {
//                         vertical: "bottom",
//                         horizontal: "left"
//                       },
//                       transformOrigin: {
//                         vertical: "top",
//                         horizontal: "left"
//                       },
//                       getContentAnchorEl: null,
//                     }}
//                     sx={{
//                       borderRadius: '8px',
//                       '& .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#3C50E0',
//                       },
//                     }}
//                   >
//                     <MenuItem value="" disabled>
//                       {isLoadingLeagues ? (
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <CircularProgress size={16} />
//                           <Typography sx={{ color: '#9CA3AF' }}>Loading leagues...</Typography>
//                         </Box>
//                       ) : (
//                         <Typography sx={{ color: '#9CA3AF' }}>Select a league</Typography>
//                       )}
//                     </MenuItem>
//                     {availableLeagues.map((league) => (
//                       <MenuItem key={league.id} value={league.name}>
//                         {league.name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               ) : (
//                 // Text field for other games
//                 <TextField
//                   fullWidth
//                   placeholder="Enter the league name"
//                   value={leagueName}
//                   onChange={(e) => setLeagueName(e.target.value)}
//                   disabled={isUploading}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: '8px',
//                       '& fieldset': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover fieldset': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused fieldset': {
//                         borderColor: '#3C50E0',
//                       },
//                     },
//                     '& .MuiInputBase-input': {
//                       padding: '12px 14px',
//                       fontSize: '14px'
//                     }
//                   }}
//                 />
//               )}
//             </Box>
//           )}


//           {gameSelection &&  (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Logo
//               </Typography>

//               <Box
//                 sx={{
//                   border: '2px dashed #D1D5DB',
//                   borderRadius: '8px',
//                   p: 4,
//                   textAlign: 'center',
//                   cursor: isUploading ? 'not-allowed' : 'pointer',
//                   transition: 'all 0.2s',
//                   opacity: isUploading ? 0.6 : 1,
//                   '&:hover': !isUploading && {
//                     borderColor: '#9CA3AF',
//                     backgroundColor: '#F9FAFB'
//                   }
//                 }}
//                 onClick={() => !isUploading && document.getElementById('edit-league-logo-upload').click()}
//               >
//                 {isUploading ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       Uploading image...
//                     </Typography>
//                   </Box>
//                 ) : logoPreview ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <img
//                       src={logoPreview}
//                       alt="League logo preview"
//                       style={{
//                         width: '60px',
//                         height: '60px',
//                         objectFit: 'cover',
//                         borderRadius: '8px'
//                       }}
//                     />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
//                       Click to change logo
//                     </Typography>
//                   </Box>
//                 ) : (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       Click to upload league logo
//                     </Typography>
//                     <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
//                       PNG, JPG, GIF up to 10MB
//                     </Typography>
//                   </Box>
//                 )}

//                 <input
//                   id="edit-league-logo-upload"
//                   type="file"
//                   accept="image/*"
//                   onChange={handleFileUpload}
//                   disabled={isUploading}
//                   style={{ display: 'none' }}
//                 />
//               </Box>

//               {/* Error Message */}
//               {uploadError && (
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: '#EF4444',
//                     fontSize: '12px',
//                     mt: 1
//                   }}
//                 >
//                   {uploadError}
//                 </Typography>
//               )}
//             </Box>
//           )}
//         </Stack>
//       </DialogContent>

//       <DialogActions
//         sx={{
//           p: 3,
//           borderTop: '1px solid #E5E7EB',
//           justifyContent: 'flex-end',
//           gap: 2
//         }}
//       >
//         <Button
//           onClick={handleCancel}
//           disabled={isUploading}
//           sx={{
//             color: '#6B7280',
//             backgroundColor: 'transparent',
//             border: 'none',
//             '&:hover': {
//               backgroundColor: '#F9FAFB'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 500,
//             px: 3
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           onClick={handleUpdate}
//           disabled={!isFormValid}
//           sx={{
//             backgroundColor: '#3C50E0',
//             color: '#fff',
//             '&:hover': { backgroundColor: '#2F4BCE' },
//             '&:disabled': {
//               backgroundColor: '#D1D5DB',
//               color: '#9CA3AF'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 600,
//             px: 3,
//             minWidth: '80px'
//           }}
//         >
//           {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Update'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };


// const CreateNewLeagueModal = ({ open, onClose, onSave, selectedGame, gamesData, onRefreshLeagues }) => {
//   const [gameSelection, setGameSelection] = useState(selectedGame || '');
//   const [leagueName, setLeagueName] = useState('');
//   const [leagueNameType, setLeagueNameType] = useState('text'); // 'text' or 'dropdown'
//   const [availableLeagues, setAvailableLeagues] = useState([]);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreview, setLogoPreview] = useState('');
//   const [isUploading, setIsUploading] = useState(false);
//   const [isLoadingLeagues, setIsLoadingLeagues] = useState(false);
//   const [uploadError, setUploadError] = useState('');

//   // Reset form when modal opens
//   // useEffect(() => {
//   //   if (open) {
//   //     setGameSelection(selectedGame || '');
//   //     setLeagueName('');
//   //     setLeagueNameType('text');
//   //     setAvailableLeagues([]);
//   //     setLogoFile(null);
//   //     setLogoPreview('');
//   //     setIsUploading(false);
//   //     setIsLoadingLeagues(false);
//   //     setUploadError('');
//   //   }
//   // }, [open, selectedGame]);

//   useEffect(() => {
//   if (open) {
//     const initialGameSelection = selectedGame || '';
//     setGameSelection(initialGameSelection);
//     setLeagueName('');
//     setLeagueNameType('text');
//     setAvailableLeagues([]);
//     setLogoFile(null);
//     setLogoPreview('');
//     setIsUploading(false);
//     setIsLoadingLeagues(false);
//     setUploadError('');

//     const selectedGameData = gamesData.find(game => game.id === initialGameSelection);
//     if (selectedGameData?.game_name.toLowerCase() === 'football') {
//       setLeagueNameType('dropdown');
//       fetchAvailableLeagues();
//     }
//   }
// }, [open, selectedGame, gamesData]);


//   // Get selected game object to access game name
//   const selectedGameObj = gamesData.find(game => game.id === gameSelection);

//   // Fetch leagues when game changes
//   useEffect(() => {
//     if (selectedGameObj && selectedGameObj.game_name.toLowerCase() === 'football') {
//       fetchAvailableLeagues();
//       setLeagueNameType('dropdown');
//     } else {
//       setLeagueNameType('text');
//       setAvailableLeagues([]);
//     }
//     setLeagueName('');
//   }, [gameSelection, selectedGameObj]);

//   const fetchAvailableLeagues = async () => {
//     setIsLoadingLeagues(true);
//     try {
//       const response = await Axios.get(`${base_url}/api/pot/leagues`, Config);
//        console.log(response, "response111")
//       let leaquename = response?.data?.data.map((item) => {
//         return {
//           ...item,
//           id: item?.league_id,
//           name: `${item?.league_name} - ${item?.country}`,
//         }
//       });
//       //console.log(leaquename, "leaquename");
//       setAvailableLeagues(leaquename);

//     } catch (error) {
//       console.error('Error fetching leagues:', error);
//       setUploadError('Failed to load leagues. Please try again.');
//     } finally {
//       setIsLoadingLeagues(false);
//     }
//   };

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.startsWith('image/')) {
//         setUploadError('Please select an image file');
//         return;
//       }

//       // Validate file size (10MB limit)
//       if (file.size > 10 * 1024 * 1024) {
//         setUploadError('File size should be less than 10MB');
//         return;
//       }

//       setUploadError('');
//       setLogoFile(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setLogoPreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSave = async (shouldRefresh = false) => {
//     if (!gameSelection) {
//       setUploadError('Please select a game');
//       return;
//     }

//     if (!leagueName.trim()) {
//       setUploadError('League name is required');
//       return;
//     }

//     setIsUploading(true);
//     setUploadError('');

//     try {
//       let firebaseImageUrl = '';

//       // Upload image to Firebase if file is selected
//       if (logoFile) {
//         const uploadResult = await FirebaseImageUpload(logoFile);
//         // Remove query parameters from Firebase URL as done in CreateNewGameModal
//         firebaseImageUrl = uploadResult.split('&')[0];
//       }
//       //console.log(gameSelection, "gameSelection123")
//       // Prepare payload with game ID (not game name)
//       const leaguePayload = {
//         name: leagueName.trim(),
//         game: gameSelection, // This is now the game ID
//         is_system_league: false,
//         is_active: false,
//         logo_url: firebaseImageUrl || ''
//       };

//       //console.log('League payload:', leaguePayload);

//       // Call API to create league
//       const response = await Axios.post(
//         `${base_url}/api/pot/preferredleagues/`,
//         leaguePayload,
//         Config
//       );

//       //console.log('League creation response:', response);

//       if (response.data) {
//         // Create local league object for UI update
//         const newLeague = {
//           id: response.data.id || Date.now(),
//           name: leagueName.trim(),
//           game_id: gameSelection,
//           logo: firebaseImageUrl || '/api/placeholder/40/40',
//           shortName: leagueName.trim().substring(0, 3).toUpperCase(),
//           type: 'Manual',
//           isSelected: true,
//           ...response.data // Include any additional data from API response
//         };
//         //console.log('New league object:', newLeague);
//          const selectedGameObj = gamesData.find(game => game.id === gameSelection);
//         onSave(newLeague, selectedGameObj?.game_name);
//         handleCancel();
//         console.log('League created successfully:', response.data);
//         if (shouldRefresh && onRefreshLeagues) {
//           onRefreshLeagues();
//         }
//       }
//     } catch (error) {
//       console.error('Error creating league:', error);
//       setUploadError('Failed to create league. Please try again.');
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handleCancel = () => {
//     setGameSelection(selectedGame || '');
//     setLeagueName('');
//     setLeagueNameType('text');
//     setAvailableLeagues([]);
//     setLogoFile(null);
//     setLogoPreview('');
//     setIsUploading(false);
//     setIsLoadingLeagues(false);
//     setUploadError('');
//     onClose();
//   };

//   const isFormValid = gameSelection && leagueName.trim() && !isUploading && !isLoadingLeagues;

//   return (
//     <Dialog
//       open={open}
//       onClose={handleCancel}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: '12px',
//           maxWidth: '500px'
//         }
//       }}
//     >
//       <DialogTitle sx={{ p: 0 }}>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             p: 3,
//             borderBottom: '1px solid #E5E7EB'
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               fontSize: '18px',
//               color: '#1F2937'
//             }}
//           >
//             Create a new league
//           </Typography>
//           <IconButton
//             onClick={handleCancel}
//             disabled={isUploading}
//             sx={{
//               color: '#6B7280',
//               '&:hover': { backgroundColor: '#F3F4F6' }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         <Stack spacing={3}>
//           {/* Step 1: Game Selection Field */}
//           <Box>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#374151',
//                 fontWeight: 500,
//                 mb: 1
//               }}
//             >
//               Which sport does it belong to *
//             </Typography>
//             <FormControl fullWidth>
//               <Select
//                 value={gameSelection}
//                 onChange={(e) => setGameSelection(e.target.value)}
//                 displayEmpty
//                 disabled={isUploading}
//                 MenuProps={{
//                   PaperProps: {
//                     style: {
//                       maxHeight: 200,
//                     },
//                   },
//                   anchorOrigin: {
//                     vertical: "bottom",
//                     horizontal: "left"
//                   },
//                   transformOrigin: {
//                     vertical: "top",
//                     horizontal: "left"
//                   },
//                   getContentAnchorEl: null,
//                 }}
//                 sx={{
//                   borderRadius: '8px',
//                   '& .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#D1D5DB',
//                   },
//                   '&:hover .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#9CA3AF',
//                   },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#3C50E0',
//                   },
//                 }}
//               >
//                 <MenuItem value="" disabled>
//                   <Typography sx={{ color: '#9CA3AF' }}>Select a game</Typography>
//                 </MenuItem>
//                 {gamesData.map((game) => (
//                   <MenuItem key={game.id} value={game.id}>
//                     {game.game_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>


//           {gameSelection && (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Name *
//               </Typography>

//               {leagueNameType === 'dropdown' ? (
//                 // Dropdown for Football
//                 <FormControl fullWidth>
//                   <Select
//                     value={leagueName}
//                     onChange={(e) => setLeagueName(e.target.value)}
//                     displayEmpty
//                     disabled={isUploading || isLoadingLeagues}
//                     MenuProps={{
//                       PaperProps: {
//                         style: {
//                           maxHeight: 200,
//                         },
//                       },
//                       anchorOrigin: {
//                         vertical: "bottom",
//                         horizontal: "left"
//                       },
//                       transformOrigin: {
//                         vertical: "top",
//                         horizontal: "left"
//                       },
//                       getContentAnchorEl: null,
//                     }}
//                     sx={{
//                       borderRadius: '8px',
//                       '& .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#3C50E0',
//                       },
//                     }}
//                   >
//                     <MenuItem value="" disabled>
//                       {isLoadingLeagues ? (
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <CircularProgress size={16} />
//                           <Typography sx={{ color: '#9CA3AF' }}>Loading leagues...</Typography>
//                         </Box>
//                       ) : (
//                         <Typography sx={{ color: '#9CA3AF' }}>Select a league</Typography>
//                       )}
//                     </MenuItem>
//                     {availableLeagues.map((league) => (
//                       <MenuItem key={league.id} value={league.name}>
//                         {league.name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               ) : (
//                 // Text field for other games
//                 <TextField
//                   fullWidth
//                   placeholder="Enter the league name"
//                   value={leagueName}
//                   onChange={(e) => setLeagueName(e.target.value)}
//                   disabled={isUploading}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: '8px',
//                       '& fieldset': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover fieldset': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused fieldset': {
//                         borderColor: '#3C50E0',
//                       },
//                     },
//                     '& .MuiInputBase-input': {
//                       padding: '12px 14px',
//                       fontSize: '14px'
//                     }
//                   }}
//                 />
//               )}
//             </Box>
//           )}


//           {gameSelection && String(gameSelection) !== '5' && (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Logo
//               </Typography>

//               <Box
//                 sx={{
//                   border: '2px dashed #D1D5DB',
//                   borderRadius: '8px',
//                   p: 4,
//                   textAlign: 'center',
//                   cursor: isUploading ? 'not-allowed' : 'pointer',
//                   transition: 'all 0.2s',
//                   opacity: isUploading ? 0.6 : 1,
//                   '&:hover': !isUploading && {
//                     borderColor: '#9CA3AF',
//                     backgroundColor: '#F9FAFB'
//                   }
//                 }}
//                 onClick={() => !isUploading && document.getElementById('league-logo-upload').click()}
//               >
//                 {isUploading ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       Uploading image...
//                     </Typography>
//                   </Box>
//                 ) : logoPreview ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <img
//                       src={logoPreview}
//                       alt="League logo preview"
//                       style={{
//                         width: '60px',
//                         height: '60px',
//                         objectFit: 'cover',
//                         borderRadius: '8px'
//                       }}
//                     />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
//                       Click to change logo
//                     </Typography>
//                   </Box>
//                 ) : (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       Click to upload league logo
//                     </Typography>
//                     <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
//                       PNG, JPG, GIF up to 10MB
//                     </Typography>
//                   </Box>
//                 )}

//                 <input
//                   id="league-logo-upload"
//                   type="file"
//                   accept="image/*"
//                   onChange={handleFileUpload}
//                   disabled={isUploading}
//                   style={{ display: 'none' }}
//                 />
//               </Box>

//               {/* Error Message */}
//               {uploadError && (
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: '#EF4444',
//                     fontSize: '12px',
//                     mt: 1
//                   }}
//                 >
//                   {uploadError}
//                 </Typography>
//               )}
//             </Box>
//           )}
//         </Stack>
//       </DialogContent>

//       <DialogActions
//         sx={{
//           p: 3,
//           borderTop: '1px solid #E5E7EB',
//           justifyContent: 'flex-end',
//           gap: 2
//         }}
//       >
//         <Button
//           onClick={handleCancel}
//           disabled={isUploading}
//           sx={{
//             color: '#6B7280',
//             backgroundColor: 'transparent',
//             border: 'none',
//             '&:hover': {
//               backgroundColor: '#F9FAFB'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 500,
//             px: 3
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           onClick={handleSave}
//           disabled={!isFormValid}
//           sx={{
//             backgroundColor: '#3C50E0',
//             color: '#fff',
//             '&:hover': { backgroundColor: '#2F4BCE' },
//             '&:disabled': {
//               backgroundColor: '#D1D5DB',
//               color: '#9CA3AF'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 600,
//             px: 3,
//             minWidth: '80px'
//           }}
//         >
//           {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// const CreateNewLeagueModal = ({ open, onClose, onSave, selectedGame, gamesData, onRefreshLeagues }) => {
//   const [gameSelection, setGameSelection] = useState(selectedGame || '');
//   const [leagueName, setLeagueName] = useState('');
//   const [leagueNameType, setLeagueNameType] = useState('text'); // 'text' or 'dropdown'
//   const [availableLeagues, setAvailableLeagues] = useState([]);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreview, setLogoPreview] = useState('');
//   const [selectedLeagueData, setSelectedLeagueData] = useState(null); // New state for selected league data
//   const [isUploading, setIsUploading] = useState(false);
//   const [isLoadingLeagues, setIsLoadingLeagues] = useState(false);
//   const [uploadError, setUploadError] = useState('');

//   useEffect(() => {
//     if (open) {
//       const initialGameSelection = selectedGame || '';
//       setGameSelection(initialGameSelection);
//       setLeagueName('');
//       setLeagueNameType('text');
//       setAvailableLeagues([]);
//       setLogoFile(null);
//       setLogoPreview('');
//       setSelectedLeagueData(null); // Reset selected league data
//       setIsUploading(false);
//       setIsLoadingLeagues(false);
//       setUploadError('');

//       const selectedGameData = gamesData.find(game => game.id === initialGameSelection);
//       if (selectedGameData?.game_name.toLowerCase() === 'football') {
//         setLeagueNameType('dropdown');
//         fetchAvailableLeagues();
//       }
//     }
//   }, [open, selectedGame, gamesData]);

//   // Get selected game object to access game name
//   const selectedGameObj = gamesData.find(game => game.id === gameSelection);

//   // Fetch leagues when game changes
//   useEffect(() => {
//     if (selectedGameObj && selectedGameObj.game_name.toLowerCase() === 'football') {
//       fetchAvailableLeagues();
//       setLeagueNameType('dropdown');
//     } else {
//       setLeagueNameType('text');
//       setAvailableLeagues([]);
//       setSelectedLeagueData(null); // Reset when switching away from football
//     }
//     setLeagueName('');
//     setLogoPreview(''); // Reset logo preview when game changes
//     setLogoFile(null); // Reset logo file when game changes
//   }, [gameSelection, selectedGameObj]);

//   const fetchAvailableLeagues = async () => {
//     setIsLoadingLeagues(true);
//     try {
//       const response = await Axios.get(`${base_url}/api/pot/leagues`, Config);
//       console.log(response, "response111");
//       let leaquename = response?.data?.data.map((item) => {
//         return {
//           ...item,
//           id: item?.league_id,
//           name: `${item?.league_name} - ${item?.country}`,
//         }
//       });
//       setAvailableLeagues(leaquename);
//     } catch (error) {
//       console.error('Error fetching leagues:', error);
//       setUploadError('Failed to load leagues. Please try again.');
//     } finally {
//       setIsLoadingLeagues(false);
//     }
//   };

//   // Handle league selection for football
//   const handleLeagueSelection = (selectedLeagueName) => {
//     setLeagueName(selectedLeagueName);

//     // Find the selected league data
//     const selectedLeague = availableLeagues.find(league => league.name === selectedLeagueName);
//     if (selectedLeague) {
//       setSelectedLeagueData(selectedLeague);
//       // Set the logo preview to the league's logo URL
//       if (selectedLeague.logo) {
//         setLogoPreview(selectedLeague.logo);
//         setLogoFile(null); // Clear any uploaded file since we're using the API logo
//       }
//     }
//   };

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.startsWith('image/')) {
//         setUploadError('Please select an image file');
//         return;
//       }

//       // Validate file size (10MB limit)
//       if (file.size > 10 * 1024 * 1024) {
//         setUploadError('File size should be less than 10MB');
//         return;
//       }

//       setUploadError('');
//       setLogoFile(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setLogoPreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSave = async (shouldRefresh = false) => {
//     if (!gameSelection) {
//       setUploadError('Please select a game');
//       return;
//     }

//     if (!leagueName.trim()) {
//       setUploadError('League name is required');
//       return;
//     }

//     setIsUploading(true);
//     setUploadError('');

//     try {
//       let firebaseImageUrl = '';

//       // For football leagues, use the API logo URL if no custom file is uploaded
//       if (selectedGameObj?.game_name.toLowerCase() === 'football' && selectedLeagueData?.logo && !logoFile) {
//         firebaseImageUrl = selectedLeagueData.logo;
//       } else if (logoFile) {
//         // Upload custom image to Firebase if file is selected
//         const uploadResult = await FirebaseImageUpload(logoFile);
//         // Remove query parameters from Firebase URL as done in CreateNewGameModal
//         firebaseImageUrl = uploadResult.split('&')[0];
//       }

//       // Prepare payload with game ID (not game name)
//       const leaguePayload = {
//         name: leagueName.trim(),
//         game: gameSelection, // This is now the game ID
//         is_system_league: false,
//         is_active: false,
//         logo_url: firebaseImageUrl || '',
//         // Include additional league data for football leagues
//         ...(selectedLeagueData && {
//           system_league_id: selectedLeagueData.system_league_id,
//           country: selectedLeagueData.country,
//           type: selectedLeagueData.type
//         })
//       };

//       // Call API to create league
//       const response = await Axios.post(
//         `${base_url}/api/pot/preferredleagues/`,
//         leaguePayload,
//         Config
//       );

//       if (response.data) {
//         // Create local league object for UI update
//         const newLeague = {
//           id: response.data.id || Date.now(),
//           name: leagueName.trim(),
//           game_id: gameSelection,
//           logo: firebaseImageUrl || '/api/placeholder/40/40',
//           shortName: leagueName.trim().substring(0, 3).toUpperCase(),
//           type: selectedLeagueData?.type || 'Manual',
//           isSelected: true,
//           ...response.data // Include any additional data from API response
//         };

//         const selectedGameObj = gamesData.find(game => game.id === gameSelection);
//         onSave(newLeague, selectedGameObj?.game_name);
//         handleCancel();
//         console.log('League created successfully:', response.data);
//         if (shouldRefresh && onRefreshLeagues) {
//           onRefreshLeagues();
//         }
//       }
//     } catch (error) {
//       console.error('Error creating league:', error);
//       setUploadError('Failed to create league. Please try again.');
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handleCancel = () => {
//     setGameSelection(selectedGame || '');
//     setLeagueName('');
//     setLeagueNameType('text');
//     setAvailableLeagues([]);
//     setLogoFile(null);
//     setLogoPreview('');
//     setSelectedLeagueData(null);
//     setIsUploading(false);
//     setIsLoadingLeagues(false);
//     setUploadError('');
//     onClose();
//   };

//   const isFormValid = gameSelection && leagueName.trim() && !isUploading && !isLoadingLeagues;

//   // Check if current game is football
//   const isFootballGame = selectedGameObj?.game_name.toLowerCase() === 'football';

//   return (
//     <Dialog
//       open={open}
//       onClose={handleCancel}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: '12px',
//           maxWidth: '500px'
//         }
//       }}
//     >
//       <DialogTitle sx={{ p: 0 }}>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             p: 3,
//             borderBottom: '1px solid #E5E7EB'
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               fontSize: '18px',
//               color: '#1F2937'
//             }}
//           >
//             Create a new league
//           </Typography>
//           <IconButton
//             onClick={handleCancel}
//             disabled={isUploading}
//             sx={{
//               color: '#6B7280',
//               '&:hover': { backgroundColor: '#F3F4F6' }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         <Stack spacing={3}>
//           {/* Step 1: Game Selection Field */}
//           <Box>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#374151',
//                 fontWeight: 500,
//                 mb: 1
//               }}
//             >
//               Which sport does it belong to *
//             </Typography>
//             <FormControl fullWidth>
//               <Select
//                 value={gameSelection}
//                 onChange={(e) => setGameSelection(e.target.value)}
//                 displayEmpty
//                 disabled={isUploading}
//                 MenuProps={{
//                   PaperProps: {
//                     style: {
//                       maxHeight: 200,
//                     },
//                   },
//                   anchorOrigin: {
//                     vertical: "bottom",
//                     horizontal: "left"
//                   },
//                   transformOrigin: {
//                     vertical: "top",
//                     horizontal: "left"
//                   },
//                   getContentAnchorEl: null,
//                 }}
//                 sx={{
//                   borderRadius: '8px',
//                   '& .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#D1D5DB',
//                   },
//                   '&:hover .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#9CA3AF',
//                   },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#3C50E0',
//                   },
//                 }}
//               >
//                 <MenuItem value="" disabled>
//                   <Typography sx={{ color: '#9CA3AF' }}>Select a game</Typography>
//                 </MenuItem>
//                 {gamesData.map((game) => (
//                   <MenuItem key={game.id} value={game.id}>
//                     {game.game_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>

//           {gameSelection && (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Name *
//               </Typography>

//               {leagueNameType === 'dropdown' ? (
//                 // Dropdown for Football
//                 <FormControl fullWidth>
//                   <Select
//                     value={leagueName}
//                     onChange={(e) => handleLeagueSelection(e.target.value)}
//                     displayEmpty
//                     disabled={isUploading || isLoadingLeagues}
//                     MenuProps={{
//                       PaperProps: {
//                         style: {
//                           maxHeight: 200,
//                         },
//                       },
//                       anchorOrigin: {
//                         vertical: "bottom",
//                         horizontal: "left"
//                       },
//                       transformOrigin: {
//                         vertical: "top",
//                         horizontal: "left"
//                       },
//                       getContentAnchorEl: null,
//                     }}
//                     sx={{
//                       borderRadius: '8px',
//                       '& .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#3C50E0',
//                       },
//                     }}
//                   >
//                     <MenuItem value="" disabled>
//                       {isLoadingLeagues ? (
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <CircularProgress size={16} />
//                           <Typography sx={{ color: '#9CA3AF' }}>Loading leagues...</Typography>
//                         </Box>
//                       ) : (
//                         <Typography sx={{ color: '#9CA3AF' }}>Select a league</Typography>
//                       )}
//                     </MenuItem>
//                     {availableLeagues.map((league) => (
//                       <MenuItem key={league.id} value={league.name}>
//                         {league.name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               ) : (
//                 // Text field for other games
//                 <TextField
//                   fullWidth
//                   placeholder="Enter the league name"
//                   value={leagueName}
//                   onChange={(e) => setLeagueName(e.target.value)}
//                   disabled={isUploading}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: '8px',
//                       '& fieldset': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover fieldset': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused fieldset': {
//                         borderColor: '#3C50E0',
//                       },
//                     },
//                     '& .MuiInputBase-input': {
//                       padding: '12px 14px',
//                       fontSize: '14px'
//                     }
//                   }}
//                 />
//               )}
//             </Box>
//           )}

//           {/* Logo Upload Section - Now shown for all games including football */}
//           {gameSelection && (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Logo {isFootballGame && selectedLeagueData ? '' : '(Optional)'}
//               </Typography>

//               <Box
//                 sx={{
//                   border: '2px dashed #D1D5DB',
//                   borderRadius: '8px',
//                   p: 4,
//                   textAlign: 'center',
//                   cursor: isUploading ? 'not-allowed' : 'pointer',
//                   transition: 'all 0.2s',
//                   opacity: isUploading ? 0.6 : 1,
//                   '&:hover': !isUploading && {
//                     borderColor: '#9CA3AF',
//                     backgroundColor: '#F9FAFB'
//                   }
//                 }}
//                 onClick={() => !isUploading && document.getElementById('league-logo-upload').click()}
//               >
//                 {isUploading ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       Uploading image...
//                     </Typography>
//                   </Box>
//                 ) : logoPreview ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <img
//                       src={logoPreview}
//                       alt="League logo preview"
//                       style={{
//                         width: '60px',
//                         height: '60px',
//                         objectFit: 'cover',
//                         borderRadius: '8px'
//                       }}
//                     />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
//                       {isFootballGame && selectedLeagueData && !logoFile 
//                         ? 'Official league logo (click to change)' 
//                         : 'Click to change logo'
//                       }
//                     </Typography>
//                   </Box>
//                 ) : (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       Click to upload league logo
//                     </Typography>
//                     <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
//                       PNG, JPG, GIF up to 10MB
//                     </Typography>
//                   </Box>
//                 )}

//                 <input
//                   id="league-logo-upload"
//                   type="file"
//                   accept="image/*"
//                   onChange={handleFileUpload}
//                   disabled={isUploading}
//                   style={{ display: 'none' }}
//                 />
//               </Box>

//               {/* Error Message */}
//               {uploadError && (
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: '#EF4444',
//                     fontSize: '12px',
//                     mt: 1
//                   }}
//                 >
//                   {uploadError}
//                 </Typography>
//               )}
//             </Box>
//           )}
//         </Stack>
//       </DialogContent>

//       <DialogActions
//         sx={{
//           p: 3,
//           borderTop: '1px solid #E5E7EB',
//           justifyContent: 'flex-end',
//           gap: 2
//         }}
//       >
//         <Button
//           onClick={handleCancel}
//           disabled={isUploading}
//           sx={{
//             color: '#6B7280',
//             backgroundColor: 'transparent',
//             border: 'none',
//             '&:hover': {
//               backgroundColor: '#F9FAFB'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 500,
//             px: 3
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           onClick={handleSave}
//           disabled={!isFormValid}
//           sx={{
//             backgroundColor: '#3C50E0',
//             color: '#fff',
//             '&:hover': { backgroundColor: '#2F4BCE' },
//             '&:disabled': {
//               backgroundColor: '#D1D5DB',
//               color: '#9CA3AF'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 600,
//             px: 3,
//             minWidth: '80px'
//           }}
//         >
//           {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };
//Perfect Working FLow
// const EditLeagueModal = ({ open, onClose, onSave, leagueData, gamesData, onRefreshLeagues }) => {
//   const [gameSelection, setGameSelection] = useState('');
//   const [leagueName, setLeagueName] = useState('');
//   const [leagueNameType, setLeagueNameType] = useState('text'); // 'text' or 'dropdown'
//   const [availableLeagues, setAvailableLeagues] = useState([]);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreview, setLogoPreview] = useState('');
//   const [isUploading, setIsUploading] = useState(false);
//   const [isLoadingLeagues, setIsLoadingLeagues] = useState(false);
//   const [uploadError, setUploadError] = useState('');

//   useEffect(() => {
//     if (open && leagueData) {
//       const gameId = gamesData.find(game => game.id === leagueData.game)?.id || '';
//       const selectedGame = gamesData.find(game => game.id === gameId);

//       setGameSelection(gameId);
//       setLeagueName(leagueData.name || '');
//       setLogoPreview(leagueData.logo_url || '');
//       setLogoFile(null);
//       setIsUploading(false);
//       setIsLoadingLeagues(false);
//       setUploadError('');

//       if (selectedGame?.game_name?.toLowerCase() === 'football') {
//         setLeagueNameType('dropdown');
//         fetchAvailableLeagues();
//       } else {
//         setLeagueNameType('text');
//         setAvailableLeagues([]);
//       }
//     }
//   }, [open, leagueData, gamesData]);

//   // Get selected game object to access game name
//   const selectedGameObj = gamesData.find(game => game.id === gameSelection);

//   // Check if current game is football (assuming football has id 5)
//   const isFootballGame = gameSelection === '5' || selectedGameObj?.game_name?.toLowerCase() === 'football';

//   // Fetch leagues when game changes
//   useEffect(() => {
//     if (selectedGameObj && selectedGameObj.game_name.toLowerCase() === 'football') {
//       fetchAvailableLeagues();
//       setLeagueNameType('dropdown');
//     } else {
//       setLeagueNameType('text');
//       setAvailableLeagues([]);
//     }
//     // Don't reset league name when editing - keep existing value
//   }, [gameSelection, selectedGameObj]);

//   const fetchAvailableLeagues = async () => {
//     setIsLoadingLeagues(true);
//     try {
//       const response = await Axios.get(`${base_url}/api/pot/leagues`, Config);
//       let leaquename = response?.data?.data.map((item) => {
//         return {
//           ...item,
//           id: item?.league_id,
//           name: `${item?.league_name} - ${item?.country}`,
//           logo: item?.logo || `https://media.api-sports.io/football/leagues/${item?.league_id}.png` // Add logo URL
//         }
//       });
//       setAvailableLeagues(leaquename);

//     } catch (error) {
//       console.error('Error fetching leagues:', error);
//       setUploadError('Failed to load leagues. Please try again.');
//     } finally {
//       setIsLoadingLeagues(false);
//     }
//   };

//   // Handle league selection for football
//   const handleLeagueSelection = (selectedLeagueName) => {
//     setLeagueName(selectedLeagueName);

//     // Find the selected league object to get its logo
//     const selectedLeague = availableLeagues.find(league => league.name === selectedLeagueName);
//     if (selectedLeague && selectedLeague.logo) {
//       setLogoPreview(selectedLeague.logo);
//     }
//   };

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.startsWith('image/')) {
//         setUploadError('Please select an image file');
//         return;
//       }

//       // Validate file size (10MB limit)
//       if (file.size > 10 * 1024 * 1024) {
//         setUploadError('File size should be less than 10MB');
//         return;
//       }

//       setUploadError('');
//       setLogoFile(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setLogoPreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleUpdate = async (shouldRefresh = false) => {
//     if (!gameSelection) {
//       setUploadError('Please select a game');
//       return;
//     }

//     if (!leagueName.trim()) {
//       setUploadError('League name is required');
//       return;
//     }

//     setIsUploading(true);
//     setUploadError('');

//     try {
//       let firebaseImageUrl = '';

//       // For football, use the logo from API or existing logo
//       if (isFootballGame) {
//         // For football, use the logo from the selected league or keep existing
//         const selectedLeague = availableLeagues.find(league => league.name === leagueName);
//         firebaseImageUrl = selectedLeague?.logo || leagueData.logo || leagueData.logo_url || '';
//       } else {
//         // For other games, upload new image to Firebase if file is selected
//         if (logoFile) {
//           const uploadResult = await FirebaseImageUpload(logoFile);
//           // Remove query parameters from Firebase URL
//           firebaseImageUrl = uploadResult.split('&')[0];
//         } else {
//           // Keep existing logo if no new file uploaded
//           firebaseImageUrl = leagueData.logo || leagueData.logo_url || '';
//         }
//       }

//       // Prepare payload for update
//       const updatePayload = {
//         name: leagueName.trim(),
//         game_id: gameSelection,
//         is_system_league: leagueData.type === 'API' ? true : false,
//         is_active: leagueData.isSelected || false,
//         logo_url: firebaseImageUrl
//       };

//       // Call API to update league
//       const response = await Axios.patch(
//         `${base_url}/api/pot/preferredleagues/${leagueData.id}/`,
//         updatePayload,
//         Config
//       );

//       console.log(`${base_url}/api/pot/preferredleagues/${leagueData.id}/`, "URL", response, "response333")

//       if (response.data) {
//         // Create updated league object for UI update
//         const updatedLeague = {
//           ...leagueData,
//           id: leagueData.id,
//           name: leagueName.trim(),
//           game: gameSelection,
//           game_id: gameSelection,
//           logo: firebaseImageUrl,
//           shortName: leagueName.trim().substring(0, 3).toUpperCase(),
//           ...response.data // Include any additional data from API response
//         };

//         const selectedGameObj = gamesData.find(game => game.id === gameSelection);
//         const gameNameToRedirect = selectedGameObj?.game_name;
//         console.log(updatedLeague, gameNameToRedirect, "edit_gameNameToRedirect")
//         onSave(updatedLeague, gameNameToRedirect);
//         handleCancel();
//         console.log('League updated successfully:', response.data);
//         if (shouldRefresh && onRefreshLeagues) {
//           onRefreshLeagues();
//         }
//       }
//     } catch (error) {
//       console.error('Error updating league:', error);
//       setUploadError('Failed to update league. Please try again.');
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handleCancel = () => {
//     setGameSelection('');
//     setLeagueName('');
//     setLeagueNameType('text');
//     setAvailableLeagues([]);
//     setLogoFile(null);
//     setLogoPreview('');
//     setIsUploading(false);
//     setIsLoadingLeagues(false);
//     setUploadError('');
//     onClose();
//   };

//   const isFormValid = gameSelection && leagueName.trim() && !isUploading && !isLoadingLeagues;

//   return (
//     <Dialog
//       open={open}
//       onClose={handleCancel}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: '12px',
//           maxWidth: '500px'
//         }
//       }}
//     >
//       <DialogTitle sx={{ p: 0 }}>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             p: 3,
//             borderBottom: '1px solid #E5E7EB'
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               fontSize: '18px',
//               color: '#1F2937'
//             }}
//           >
//             Edit league
//           </Typography>
//           <IconButton
//             onClick={handleCancel}
//             disabled={isUploading}
//             sx={{
//               color: '#6B7280',
//               '&:hover': { backgroundColor: '#F3F4F6' }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         <Stack spacing={3}>
//           {/* Step 1: Game Selection Field */}
//           <Box>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#374151',
//                 fontWeight: 500,
//                 mb: 1
//               }}
//             >
//               Which sport does it belong to *
//             </Typography>
//             <FormControl fullWidth>
//               <Select
//                 value={gameSelection}
//                 onChange={(e) => setGameSelection(e.target.value)}
//                 displayEmpty
//                 disabled={isUploading}
//                 MenuProps={{
//                   PaperProps: {
//                     style: {
//                       maxHeight: 200,
//                     },
//                   },
//                   anchorOrigin: {
//                     vertical: "bottom",
//                     horizontal: "left"
//                   },
//                   transformOrigin: {
//                     vertical: "top",
//                     horizontal: "left"
//                   },
//                   getContentAnchorEl: null,
//                 }}
//                 sx={{
//                   borderRadius: '8px',
//                   '& .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#D1D5DB',
//                   },
//                   '&:hover .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#9CA3AF',
//                   },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#3C50E0',
//                   },
//                 }}
//               >
//                 <MenuItem value="" disabled>
//                   <Typography sx={{ color: '#9CA3AF' }}>Select a game</Typography>
//                 </MenuItem>
//                 {gamesData.map((game) => (
//                   <MenuItem key={game.id} value={game.id}>
//                     {game.game_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>

//           {gameSelection && (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Name *
//               </Typography>

//               {leagueNameType === 'dropdown' ? (
//                 // Dropdown for Football
//                 <>
//                   {/* <FormControl fullWidth>
//                   <Select
//                     value={leagueName}
//                     onChange={(e) => handleLeagueSelection(e.target.value)}
//                     displayEmpty
//                     disabled={isUploading || isLoadingLeagues}
//                     MenuProps={{
//                       PaperProps: {
//                         style: {
//                           maxHeight: 200,
//                         },
//                       },
//                       anchorOrigin: {
//                         vertical: "bottom",
//                         horizontal: "left"
//                       },
//                       transformOrigin: {
//                         vertical: "top",
//                         horizontal: "left"
//                       },
//                       getContentAnchorEl: null,
//                     }}
//                     sx={{
//                       borderRadius: '8px',
//                       '& .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#3C50E0',
//                       },
//                     }}
//                   >
//                     <MenuItem value="" disabled>
//                       {isLoadingLeagues ? (
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <CircularProgress size={16} />
//                           <Typography sx={{ color: '#9CA3AF' }}>Loading leagues...</Typography>
//                         </Box>
//                       ) : (
//                         <Typography sx={{ color: '#9CA3AF' }}>Select a league</Typography>
//                       )}
//                     </MenuItem>
//                     {availableLeagues.map((league) => (
//                       <MenuItem key={league.id} value={league.name}>
//                         {league.name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl> */}
//                   <Autocomplete
//                     fullWidth
//                     disabled={isUploading || isLoadingLeagues}
//                     options={availableLeagues}
//                     getOptionLabel={(option) => option.name}
//                     value={availableLeagues.find(league => league.name === leagueName) || null}
//                     onChange={(event, newValue) => {
//                       if (newValue) handleLeagueSelection(newValue.name);
//                     }}
//                     loading={isLoadingLeagues}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         placeholder="Search and select a league"
//                         InputProps={{
//                           ...params.InputProps,
//                           endAdornment: (
//                             <>
//                               {isLoadingLeagues ? <CircularProgress size={20} /> : null}
//                               {params.InputProps.endAdornment}
//                             </>
//                           ),
//                         }}
//                         sx={{
//                           '& .MuiOutlinedInput-root': {
//                             borderRadius: '8px',
//                             '& fieldset': {
//                               borderColor: '#D1D5DB',
//                             },
//                             '&:hover fieldset': {
//                               borderColor: '#9CA3AF',
//                             },
//                             '&.Mui-focused fieldset': {
//                               borderColor: '#3C50E0',
//                             },
//                           },
//                           '& .MuiInputBase-input': {
//                             padding: '12px 14px',
//                             fontSize: '14px'
//                           }
//                         }}
//                       />
//                     )}
//                   />
//                 </>
//               ) : (
//                 // Text field for other games
//                 <TextField
//                   fullWidth
//                   placeholder="Enter the league name"
//                   value={leagueName}
//                   onChange={(e) => setLeagueName(e.target.value)}
//                   disabled={isUploading}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: '8px',
//                       '& fieldset': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover fieldset': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused fieldset': {
//                         borderColor: '#3C50E0',
//                       },
//                     },
//                     '& .MuiInputBase-input': {
//                       padding: '12px 14px',
//                       fontSize: '14px'
//                     }
//                   }}
//                 />
//               )}
//             </Box>
//           )}

//           {/* Logo Upload Section - Now shows for all games including football */}
//           {gameSelection && (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Logo
//               </Typography>

//               <Box
//                 sx={{
//                   border: '2px dashed #D1D5DB',
//                   borderRadius: '8px',
//                   p: 4,
//                   textAlign: 'center',
//                   cursor: (isUploading || isFootballGame) ? 'not-allowed' : 'pointer',
//                   transition: 'all 0.2s',
//                   opacity: isUploading ? 0.6 : 1,
//                   backgroundColor: isFootballGame ? '#F9FAFB' : 'transparent',
//                   '&:hover': (!isUploading && !isFootballGame) && {
//                     borderColor: '#9CA3AF',
//                     backgroundColor: '#F9FAFB'
//                   }
//                 }}
//                 onClick={() => !isUploading && !isFootballGame && document.getElementById('edit-league-logo-upload').click()}
//               >
//                 {isUploading ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       Uploading image...
//                     </Typography>
//                   </Box>
//                 ) : logoPreview ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <img
//                       src={logoPreview}
//                       alt="League logo preview"
//                       style={{
//                         width: '60px',
//                         height: '60px',
//                         objectFit: 'cover',
//                         borderRadius: '8px'
//                       }}
//                     />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
//                       {isFootballGame ? 'League logo from API' : 'Click to change logo'}
//                     </Typography>
//                   </Box>
//                 ) : (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       {isFootballGame ? 'Logo will be fetched from API' : 'Click to upload league logo'}
//                     </Typography>
//                     {!isFootballGame && (
//                       <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
//                         PNG, JPG, GIF up to 10MB
//                       </Typography>
//                     )}
//                   </Box>
//                 )}

//                 {/* File input - only enabled for non-football games */}
//                 <input
//                   id="edit-league-logo-upload"
//                   type="file"
//                   accept="image/*"
//                   onChange={handleFileUpload}
//                   disabled={isUploading || isFootballGame}
//                   style={{ display: 'none' }}
//                 />
//               </Box>

//               {/* Info message for football */}
//               {isFootballGame && (
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: '#6B7280',
//                     fontSize: '12px',
//                     mt: 1,
//                     fontStyle: 'italic'
//                   }}
//                 >
//                   Logo is automatically fetched from the API for football leagues
//                 </Typography>
//               )}

//               {/* Error Message */}
//               {uploadError && (
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: '#EF4444',
//                     fontSize: '12px',
//                     mt: 1
//                   }}
//                 >
//                   {uploadError}
//                 </Typography>
//               )}
//             </Box>
//           )}
//         </Stack>
//       </DialogContent>

//       <DialogActions
//         sx={{
//           p: 3,
//           borderTop: '1px solid #E5E7EB',
//           justifyContent: 'flex-end',
//           gap: 2
//         }}
//       >
//         <Button
//           onClick={handleCancel}
//           disabled={isUploading}
//           sx={{
//             color: '#6B7280',
//             backgroundColor: 'transparent',
//             border: 'none',
//             '&:hover': {
//               backgroundColor: '#F9FAFB'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 500,
//             px: 3
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           onClick={handleUpdate}
//           disabled={!isFormValid}
//           sx={{
//             backgroundColor: '#3C50E0',
//             color: '#fff',
//             '&:hover': { backgroundColor: '#2F4BCE' },
//             '&:disabled': {
//               backgroundColor: '#D1D5DB',
//               color: '#9CA3AF'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 600,
//             px: 3,
//             minWidth: '80px'
//           }}
//         >
//           {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Update'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

const EditLeagueModal = ({ open, onClose, onSave, leagueData, gamesData, onRefreshLeagues }) => {
  const [gameSelection, setGameSelection] = useState('');
  const [leagueName, setLeagueName] = useState('');
  const [leagueNameType, setLeagueNameType] = useState('text'); // 'text' or 'dropdown'
  const [availableLeagues, setAvailableLeagues] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [isLoadingLeagues, setIsLoadingLeagues] = useState(false);
  const [uploadError, setUploadError] = useState('');
  
  // Add notification states
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  useEffect(() => {
    if (open && leagueData) {
      const gameId = gamesData.find(game => game.id === leagueData.game)?.id || '';
      const selectedGame = gamesData.find(game => game.id === gameId);

      setGameSelection(gameId);
      setLeagueName(leagueData.name || '');
      setLogoPreview(leagueData.logo_url || '');
      setLogoFile(null);
      setIsUploading(false);
      setIsLoadingLeagues(false);
      setUploadError('');
      // Reset notification states
      setShowNotification(false);
      setNotificationMessage('');

      if (selectedGame?.game_name?.toLowerCase() === 'football') {
        setLeagueNameType('dropdown');
        fetchAvailableLeagues();
      } else {
        setLeagueNameType('text');
        setAvailableLeagues([]);
      }
    }
  }, [open, leagueData, gamesData]);

  // Get selected game object to access game name
  const selectedGameObj = gamesData.find(game => game.id === gameSelection);

  // Check if current game is football (assuming football has id 5)
  const isFootballGame = gameSelection === '5' || selectedGameObj?.game_name?.toLowerCase() === 'football';

  // Fetch leagues when game changes
  useEffect(() => {
    if (selectedGameObj && selectedGameObj.game_name.toLowerCase() === 'football') {
      fetchAvailableLeagues();
      setLeagueNameType('dropdown');
    } else {
      setLeagueNameType('text');
      setAvailableLeagues([]);
    }
    // Don't reset league name when editing - keep existing value
  }, [gameSelection, selectedGameObj]);

  const fetchAvailableLeagues = async () => {
    setIsLoadingLeagues(true);
    try {
      const response = await Axios.get(`${base_url}/api/pot/leagues`, Config);
      let leaquename = response?.data?.data.map((item) => {
        return {
          ...item,
          id: item?.league_id,
          name: `${item?.league_name} - ${item?.country}`,
          logo: item?.logo || `https://media.api-sports.io/football/leagues/${item?.league_id}.png` // Add logo URL
        }
      });
      setAvailableLeagues(leaquename);

    } catch (error) {
      console.error('Error fetching leagues:', error);
      setUploadError('Failed to load leagues. Please try again.');
    } finally {
      setIsLoadingLeagues(false);
    }
  };

  // Handle league selection for football
  const handleLeagueSelection = (selectedLeagueName) => {
    setLeagueName(selectedLeagueName);

    // Find the selected league object to get its logo
    const selectedLeague = availableLeagues.find(league => league.name === selectedLeagueName);
    if (selectedLeague && selectedLeague.logo) {
      setLogoPreview(selectedLeague.logo);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        setUploadError('Please select an image file');
        return;
      }

      // Validate file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        setUploadError('File size should be less than 10MB');
        return;
      }

      // Create an image element to check dimensions
      const img = new Image();
      const reader = new FileReader();
      
      reader.onload = (e) => {
        img.onload = () => {
          // Check image dimensions
          if (img.width > 100 || img.height > 100) {
            setUploadError(`Image dimensions should not exceed 100x100 pixels. Current size: ${img.width}x${img.height}px`);
            // Clear the file input
            event.target.value = '';
            return;
          }
          
          // If all validations pass, set the file and preview
          setUploadError('');
          setLogoFile(file);
          setLogoPreview(e.target.result);
        };
        
        img.onerror = () => {
          setUploadError('Failed to load image. Please try another file.');
          event.target.value = '';
        };
        
        img.src = e.target.result;
      };
      
      reader.onerror = () => {
        setUploadError('Failed to read file. Please try again.');
        event.target.value = '';
      };
      
      reader.readAsDataURL(file);
    }
  };

  const handleUpdate = async (shouldRefresh = false) => {
    if (!gameSelection) {
      setUploadError('Please select a game');
      return;
    }

    if (!leagueName.trim()) {
      setUploadError('League name is required');
      return;
    }

    setIsUploading(true);
    setUploadError('');

    try {
      let firebaseImageUrl = '';

      // For football, use the logo from API or existing logo
      if (isFootballGame) {
        // For football, use the logo from the selected league or keep existing
        const selectedLeague = availableLeagues.find(league => league.name === leagueName);
        firebaseImageUrl = selectedLeague?.logo || leagueData.logo || leagueData.logo_url || '';
      } else {
        // For other games, upload new image to Firebase if file is selected
        if (logoFile) {
          const uploadResult = await FirebaseImageUpload(logoFile);
          // Remove query parameters from Firebase URL
          firebaseImageUrl = uploadResult.split('&')[0];
        } else {
          // Keep existing logo if no new file uploaded
          firebaseImageUrl = leagueData.logo || leagueData.logo_url || '';
        }
      }

      // Prepare payload for update
      const updatePayload = {
        name: leagueName.trim(),
        game_id: gameSelection,
        is_system_league: leagueData.type === 'API' ? true : false,
        is_active: leagueData.isSelected || false,
        logo_url: firebaseImageUrl
      };

      // Call API to update league
      const response = await Axios.patch(
        `${base_url}/api/pot/preferredleagues/${leagueData.id}/`,
        updatePayload,
        Config
      );

      console.log(`${base_url}/api/pot/preferredleagues/${leagueData.id}/`, "URL", response, "response333")

      if (response.data) {
        // Create updated league object for UI update
        const updatedLeague = {
          ...leagueData,
          id: leagueData.id,
          name: leagueName.trim(),
          game: gameSelection,
          game_id: gameSelection,
          logo: firebaseImageUrl,
          shortName: leagueName.trim().substring(0, 3).toUpperCase(),
          ...response.data // Include any additional data from API response
        };

        const selectedGameObj = gamesData.find(game => game.id === gameSelection);
        const gameNameToRedirect = selectedGameObj?.game_name;
        console.log(updatedLeague, gameNameToRedirect, "edit_gameNameToRedirect")
        onSave(updatedLeague, gameNameToRedirect);
        handleCancel();
        console.log('League updated successfully:', response.data);
        if (shouldRefresh && onRefreshLeagues) {
          onRefreshLeagues();
        }
      }
    } catch (error) {
      console.error('Error updating league:', error);
      
      // Handle API validation errors and show notification
      if (error.response?.data) {
        const errorData = error.response.data;
        let errorMessage = 'Failed to update league. Please try again.';
        
        // Check if it's a validation error with field-specific messages
        if (typeof errorData === 'object' && errorData.name) {
          // Handle name field errors (array format)
          if (Array.isArray(errorData.name)) {
            errorMessage = errorData.name[0]; // Display first error message
          } else {
            errorMessage = errorData.name;
          }
        } else if (errorData.detail) {
          // Handle general detail error messages
          errorMessage = errorData.detail;
        } else if (errorData.message) {
          // Handle general message error
          errorMessage = errorData.message;
        } else if (typeof errorData === 'string') {
          // Handle string error responses
          errorMessage = errorData;
        }
        
        // Show notification instead of setting uploadError
        setNotificationMessage(errorMessage);
        setShowNotification(true);
      } else if (error.message) {
        setNotificationMessage(error.message);
        setShowNotification(true);
      } else {
        setNotificationMessage('Failed to update league. Please try again.');
        setShowNotification(true);
      }
    } finally {
      setIsUploading(false);
    }
  };

  const handleCancel = () => {
    setGameSelection('');
    setLeagueName('');
    setLeagueNameType('text');
    setAvailableLeagues([]);
    setLogoFile(null);
    setLogoPreview('');
    setIsUploading(false);
    setIsLoadingLeagues(false);
    setUploadError('');
    // Reset notification states
    setShowNotification(false);
    setNotificationMessage('');
    onClose();
  };

  const isFormValid = gameSelection && leagueName.trim() && !isUploading && !isLoadingLeagues;

  return (
    <>
      {/* Notification Component */}
      <Notification 
        show={showNotification}
        type="error"
        message={notificationMessage}
        setopen={setShowNotification}
      />
      
      <Dialog
        open={open}
        onClose={handleCancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            maxWidth: '500px'
          }
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 3,
              borderBottom: '1px solid #E5E7EB'
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: '#1F2937'
              }}
            >
              Edit league
            </Typography>
            <IconButton
              onClick={handleCancel}
              disabled={isUploading}
              sx={{
                color: '#6B7280',
                '&:hover': { backgroundColor: '#F3F4F6' }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Stack spacing={3}>
            {/* Step 1: Game Selection Field */}
            <Box>
              <Typography
                variant="body2"
                sx={{
                  color: '#374151',
                  fontWeight: 500,
                  mb: 1
                }}
              >
                Which sport does it belong to *
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={gameSelection}
                  onChange={(e) => setGameSelection(e.target.value)}
                  displayEmpty
                  disabled={isUploading}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                      },
                    },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null,
                  }}
                  sx={{
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#D1D5DB',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#9CA3AF',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3C50E0',
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    <Typography sx={{ color: '#9CA3AF' }}>Select a game</Typography>
                  </MenuItem>
                  {gamesData.map((game) => (
                    <MenuItem key={game.id} value={game.id}>
                      {game.game_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {gameSelection && (
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#374151',
                    fontWeight: 500,
                    mb: 1
                  }}
                >
                  League Name *
                </Typography>

                {leagueNameType === 'dropdown' ? (
                  // Dropdown for Football
                  <>
                    <Autocomplete
                      fullWidth
                      disabled={isUploading || isLoadingLeagues}
                      options={availableLeagues}
                      getOptionLabel={(option) => option.name}
                      value={availableLeagues.find(league => league.name === leagueName) || null}
                      onChange={(event, newValue) => {
                        if (newValue) handleLeagueSelection(newValue.name);
                      }}
                      loading={isLoadingLeagues}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search and select a league"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {isLoadingLeagues ? <CircularProgress size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              '& fieldset': {
                                borderColor: '#D1D5DB',
                              },
                              '&:hover fieldset': {
                                borderColor: '#9CA3AF',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#3C50E0',
                              },
                            },
                            '& .MuiInputBase-input': {
                              padding: '12px 14px',
                              fontSize: '14px'
                            }
                          }}
                        />
                      )}
                    />
                  </>
                ) : (
                  // Text field for other games
                  <TextField
                    fullWidth
                    placeholder="Enter the league name"
                    value={leagueName}
                    onChange={(e) => setLeagueName(e.target.value)}
                    disabled={isUploading}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        '& fieldset': {
                          borderColor: '#D1D5DB',
                        },
                        '&:hover fieldset': {
                          borderColor: '#9CA3AF',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#3C50E0',
                        },
                      },
                      '& .MuiInputBase-input': {
                        padding: '12px 14px',
                        fontSize: '14px'
                      }
                    }}
                  />
                )}
              </Box>
            )}

            {/* Logo Upload Section - Now shows for all games including football */}
            {gameSelection && (
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#374151',
                    fontWeight: 500,
                    mb: 1
                  }}
                >
                  League Logo
                </Typography>

                <Box
                  sx={{
                    border: '2px dashed #D1D5DB',
                    borderRadius: '8px',
                    p: 4,
                    textAlign: 'center',
                    cursor: (isUploading || isFootballGame) ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s',
                    opacity: isUploading ? 0.6 : 1,
                    backgroundColor: isFootballGame ? '#F9FAFB' : 'transparent',
                    '&:hover': (!isUploading && !isFootballGame) && {
                      borderColor: '#9CA3AF',
                      backgroundColor: '#F9FAFB'
                    }
                  }}
                  onClick={() => !isUploading && !isFootballGame && document.getElementById('edit-league-logo-upload').click()}
                >
                  {isUploading ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                      <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
                      <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
                        Uploading image...
                      </Typography>
                    </Box>
                  ) : logoPreview ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                      <img
                        src={logoPreview}
                        alt="League logo preview"
                        style={{
                          width: '60px',
                          height: '60px',
                          objectFit: 'cover',
                          borderRadius: '8px'
                        }}
                      />
                      <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
                        {isFootballGame ? 'League logo from API' : 'Click to change logo'}
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                      <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
                      <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
                        {isFootballGame ? 'Logo will be fetched from API' : 'Click to upload league logo'}
                      </Typography>
                      {!isFootballGame && (
                        <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
                          PNG, JPG, GIF up to 10MB (Max: 100x100px)
                        </Typography>
                      )}
                    </Box>
                  )}

                  {/* File input - only enabled for non-football games */}
                  <input
                    id="edit-league-logo-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleFileUpload}
                    disabled={isUploading || isFootballGame}
                    style={{ display: 'none' }}
                  />
                </Box>

                {/* Info message for football */}
                {isFootballGame && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#6B7280',
                      fontSize: '12px',
                      mt: 1,
                      fontStyle: 'italic'
                    }}
                  >
                    Logo is automatically fetched from the API for football leagues
                  </Typography>
                )}

                {/* Error Message - Only show for non-football games and non-API errors */}
                {uploadError && !isFootballGame && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#EF4444',
                      fontSize: '12px',
                      mt: 1
                    }}
                  >
                    {uploadError}
                  </Typography>
                )}
              </Box>
            )}
          </Stack>
        </DialogContent>

        <DialogActions
          sx={{
            p: 3,
            borderTop: '1px solid #E5E7EB',
            justifyContent: 'flex-end',
            gap: 2
          }}
        >
          <Button
            onClick={handleCancel}
            disabled={isUploading}
            sx={{
              color: '#6B7280',
              backgroundColor: 'transparent',
              border: 'none',
              '&:hover': {
                backgroundColor: '#F9FAFB'
              },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500,
              px: 3
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleUpdate}
            disabled={!isFormValid}
            sx={{
              backgroundColor: '#3C50E0',
              color: '#fff',
              '&:hover': { backgroundColor: '#2F4BCE' },
              '&:disabled': {
                backgroundColor: '#D1D5DB',
                color: '#9CA3AF'
              },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              minWidth: '80px'
            }}
          >
            {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

//Old Code Before Add the Notification and Search bar at the dropdwon
// const CreateNewLeagueModal = ({ open, onClose, onSave, selectedGame, gamesData, onRefreshLeagues }) => {
//   const [gameSelection, setGameSelection] = useState(selectedGame || '');
//   const [leagueName, setLeagueName] = useState('');
//   const [leagueNameType, setLeagueNameType] = useState('text'); // 'text' or 'dropdown'
//   const [availableLeagues, setAvailableLeagues] = useState([]);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreview, setLogoPreview] = useState('');
//   const [selectedLeagueData, setSelectedLeagueData] = useState(null); // New state for selected league data
//   const [isUploading, setIsUploading] = useState(false);
//   const [isLoadingLeagues, setIsLoadingLeagues] = useState(false);
//   const [uploadError, setUploadError] = useState('');

//   useEffect(() => {
//     if (open) {
//       const initialGameSelection = selectedGame || '';
//       setGameSelection(initialGameSelection);
//       setLeagueName('');
//       setLeagueNameType('text');
//       setAvailableLeagues([]);
//       setLogoFile(null);
//       setLogoPreview('');
//       setSelectedLeagueData(null); // Reset selected league data
//       setIsUploading(false);
//       setIsLoadingLeagues(false);
//       setUploadError('');

//       const selectedGameData = gamesData.find(game => game.id === initialGameSelection);
//       if (selectedGameData?.game_name.toLowerCase() === 'football') {
//         setLeagueNameType('dropdown');
//         fetchAvailableLeagues();
//       }
//     }
//   }, [open, selectedGame, gamesData]);

//   // Get selected game object to access game name
//   const selectedGameObj = gamesData.find(game => game.id === gameSelection);

//   // Fetch leagues when game changes
//   useEffect(() => {
//     if (selectedGameObj && selectedGameObj.game_name.toLowerCase() === 'football') {
//       fetchAvailableLeagues();
//       setLeagueNameType('dropdown');
//     } else {
//       setLeagueNameType('text');
//       setAvailableLeagues([]);
//       setSelectedLeagueData(null); // Reset when switching away from football
//     }
//     setLeagueName('');
//     setLogoPreview(''); // Reset logo preview when game changes
//     setLogoFile(null); // Reset logo file when game changes
//   }, [gameSelection, selectedGameObj]);

//   const fetchAvailableLeagues = async () => {
//     setIsLoadingLeagues(true);
//     try {
//       const response = await Axios.get(`${base_url}/api/pot/leagues`, Config);
//       console.log(response, "response111");
//       let leaquename = response?.data?.data.map((item) => {
//         return {
//           ...item,
//           id: item?.league_id,
//           name: `${item?.league_name} - ${item?.country}`,
//         }
//       });
//       setAvailableLeagues(leaquename);
//     } catch (error) {
//       console.error('Error fetching leagues:', error);
//       setUploadError('Failed to load leagues. Please try again.');
//     } finally {
//       setIsLoadingLeagues(false);
//     }
//   };

//   // Handle league selection for football
//   const handleLeagueSelection = (selectedLeagueName) => {
//     setLeagueName(selectedLeagueName);

//     // Find the selected league data
//     const selectedLeague = availableLeagues.find(league => league.name === selectedLeagueName);
//     if (selectedLeague) {
//       setSelectedLeagueData(selectedLeague);
//       // Set the logo preview to the league's logo URL
//       if (selectedLeague.logo) {
//         setLogoPreview(selectedLeague.logo);
//         setLogoFile(null); // Clear any uploaded file since we're using the API logo
//       }
//     }
//   };

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.startsWith('image/')) {
//         setUploadError('Please select an image file');
//         return;
//       }

//       // Validate file size (10MB limit)
//       if (file.size > 10 * 1024 * 1024) {
//         setUploadError('File size should be less than 10MB');
//         return;
//       }

//       setUploadError('');
//       setLogoFile(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setLogoPreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // const handleSave = async (shouldRefresh = false) => {
//   //   if (!gameSelection) {
//   //     setUploadError('Please select a game');
//   //     return;
//   //   }

//   //   if (!leagueName.trim()) {
//   //     setUploadError('League name is required');
//   //     return;
//   //   }

//   //   setIsUploading(true);
//   //   setUploadError('');

//   //   try {
//   //     let firebaseImageUrl = '';

//   //     // For football leagues, always use the API logo URL (no custom upload allowed)
//   //     if (selectedGameObj?.game_name.toLowerCase() === 'football' && selectedLeagueData?.logo) {
//   //       firebaseImageUrl = selectedLeagueData.logo;
//   //     } else if (logoFile && selectedGameObj?.game_name.toLowerCase() !== 'football') {
//   //       // Upload custom image to Firebase only for non-football games
//   //       const uploadResult = await FirebaseImageUpload(logoFile);
//   //       // Remove query parameters from Firebase URL as done in CreateNewGameModal
//   //       firebaseImageUrl = uploadResult.split('&')[0];
//   //     }

//   //     // Prepare payload with game ID (not game name)
//   //     const leaguePayload = {
//   //       name: leagueName.trim(),
//   //       game: gameSelection, // This is now the game ID
//   //       is_system_league: false,
//   //       is_active: false,
//   //       logo_url: firebaseImageUrl || '',
//   //       // Include additional league data for football leagues
//   //       ...(selectedLeagueData && {
//   //         system_league_id: selectedLeagueData.system_league_id,
//   //         country: selectedLeagueData.country,
//   //         type: selectedLeagueData.type
//   //       })
//   //     };

//   //     // Call API to create league
//   //     const response = await Axios.post(
//   //       `${base_url}/api/pot/preferredleagues/`,
//   //       leaguePayload,
//   //       Config
//   //     );

//   //     if (response.data) {
//   //       // Create local league object for UI update
//   //       const newLeague = {
//   //         id: response.data.id || Date.now(),
//   //         name: leagueName.trim(),
//   //         game_id: gameSelection,
//   //         logo: firebaseImageUrl || '/api/placeholder/40/40',
//   //         shortName: leagueName.trim().substring(0, 3).toUpperCase(),
//   //         type: selectedLeagueData?.type || 'Manual',
//   //         isSelected: true,
//   //         ...response.data // Include any additional data from API response
//   //       };

//   //       const selectedGameObj = gamesData.find(game => game.id === gameSelection);
//   //       onSave(newLeague, selectedGameObj?.game_name);
//   //       handleCancel();
//   //       console.log('League created successfully:', response.data);
//   //       if (shouldRefresh && onRefreshLeagues) {
//   //         onRefreshLeagues();
//   //       }
//   //     }
//   //   } catch (error) {
//   //     // console.error('Error creating league:', error);
//   //     // setUploadError('Failed to create league. Please try again.');
//   //     console.error('Error creating league:', error);

//   // // Extract detailed error message if present
//   // const errorData = error?.response?.data;

//   // if (errorData?.name && Array.isArray(errorData.name) && errorData.name.length > 0) {
//   //   setUploadError(errorData.name[0]);
//   // } else {
//   //   setUploadError('Failed to create league. Please try again.');
//   // }
//   //   } finally {
//   //     setIsUploading(false);
//   //   }
//   // };
// const handleSave = async (shouldRefresh = false) => {
//   if (!gameSelection) {
//     setUploadError('Please select a game');
//     return;
//   }

//   if (!leagueName.trim()) {
//     setUploadError('League name is required');
//     return;
//   }

//   setIsUploading(true);
//   setUploadError('');

//   try {
//     let firebaseImageUrl = '';

//     // For football leagues, always use the API logo URL (no custom upload allowed)
//     if (selectedGameObj?.game_name.toLowerCase() === 'football' && selectedLeagueData?.logo) {
//       firebaseImageUrl = selectedLeagueData.logo;
//     } else if (logoFile && selectedGameObj?.game_name.toLowerCase() !== 'football') {
//       // Upload custom image to Firebase only for non-football games
//       const uploadResult = await FirebaseImageUpload(logoFile);
//       // Remove query parameters from Firebase URL as done in CreateNewGameModal
//       firebaseImageUrl = uploadResult.split('&')[0];
//     }

//     // Prepare payload with game ID (not game name)
//     const leaguePayload = {
//       name: leagueName.trim(),
//       game: gameSelection, // This is now the game ID
//       is_system_league: false,
//       is_active: false,
//       logo_url: firebaseImageUrl || '',
//       // Include additional league data for football leagues
//       ...(selectedLeagueData && {
//         system_league_id: selectedLeagueData.system_league_id,
//         country: selectedLeagueData.country,
//         type: selectedLeagueData.type
//       })
//     };

//     // Call API to create league
//     const response = await Axios.post(
//       `${base_url}/api/pot/preferredleagues/`,
//       leaguePayload,
//       Config
//     );

//     if (response.data) {
//       // Create local league object for UI update
//       const newLeague = {
//         id: response.data.id || Date.now(),
//         name: leagueName.trim(),
//         game_id: gameSelection,
//         logo: firebaseImageUrl || '/api/placeholder/40/40',
//         shortName: leagueName.trim().substring(0, 3).toUpperCase(),
//         type: selectedLeagueData?.type || 'Manual',
//         isSelected: true,
//         ...response.data // Include any additional data from API response
//       };

//       const selectedGameObj = gamesData.find(game => game.id === gameSelection);
//       onSave(newLeague, selectedGameObj?.game_name);
//       handleCancel();
//       console.log('League created successfully:', response.data);
//       if (shouldRefresh && onRefreshLeagues) {
//         onRefreshLeagues();
//       }
//     }
//   } catch (error) {
//     console.error('Error creating league:', error);
    
//     // Handle API validation errors
//     if (error.response?.data) {
//       const errorData = error.response.data;
//       console.log(errorData, "errorData")
//       // Check if it's a validation error with field-specific messages
//       if (typeof errorData === 'object' && errorData.name) {
//         // Handle name field errors (array format)
//         if (Array.isArray(errorData.name)) {
//           setUploadError(errorData.name[0]); // Display first error message
//         } else {
//           setUploadError(errorData.name);
//         }
//       } else if (errorData.detail) {
//         // Handle general detail error messages
//         setUploadError(errorData.detail);
//       } else if (errorData.message) {
//         // Handle general message error
//         setUploadError(errorData.message);
//       } else if (typeof errorData === 'string') {
//         // Handle string error responses
//         setUploadError(errorData);
//       } else {
//         // Fallback for unknown error formats
//         setUploadError('Failed to create league. Please try again.');
//       }
//     } else if (error.message) {
//       setUploadError(error.message);
//     } else {
//       setUploadError('Failed to create league. Please try again.');
//     }
//   } finally {
//     setIsUploading(false);
//   }
// };

//   const handleCancel = () => {
//     setGameSelection(selectedGame || '');
//     setLeagueName('');
//     setLeagueNameType('text');
//     setAvailableLeagues([]);
//     setLogoFile(null);
//     setLogoPreview('');
//     setSelectedLeagueData(null);
//     setIsUploading(false);
//     setIsLoadingLeagues(false);
//     setUploadError('');
//     onClose();
//   };

//   const isFormValid = gameSelection && leagueName.trim() && !isUploading && !isLoadingLeagues;

//   // Check if current game is football
//   const isFootballGame = selectedGameObj?.game_name.toLowerCase() === 'football';

//   return (
//     <Dialog
//       open={open}
//       onClose={handleCancel}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: '12px',
//           maxWidth: '500px'
//         }
//       }}
//     >
//       <DialogTitle sx={{ p: 0 }}>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             p: 3,
//             borderBottom: '1px solid #E5E7EB'
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               fontSize: '18px',
//               color: '#1F2937'
//             }}
//           >
//             Create a new league
//           </Typography>
//           <IconButton
//             onClick={handleCancel}
//             disabled={isUploading}
//             sx={{
//               color: '#6B7280',
//               '&:hover': { backgroundColor: '#F3F4F6' }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         <Stack spacing={3}>
//           {/* Step 1: Game Selection Field */}
//           <Box>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#374151',
//                 fontWeight: 500,
//                 mb: 1
//               }}
//             >
//               Which sport does it belong to *
//             </Typography>
//             <FormControl fullWidth>
//               <Select
//                 value={gameSelection}
//                 onChange={(e) => setGameSelection(e.target.value)}
//                 displayEmpty
//                 disabled={isUploading}
//                 MenuProps={{
//                   PaperProps: {
//                     style: {
//                       maxHeight: 200,
//                     },
//                   },
//                   anchorOrigin: {
//                     vertical: "bottom",
//                     horizontal: "left"
//                   },
//                   transformOrigin: {
//                     vertical: "top",
//                     horizontal: "left"
//                   },
//                   getContentAnchorEl: null,
//                 }}
//                 sx={{
//                   borderRadius: '8px',
//                   '& .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#D1D5DB',
//                   },
//                   '&:hover .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#9CA3AF',
//                   },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#3C50E0',
//                   },
//                 }}
//                 inputProps={{
//                   sx: {
//                     padding: '10px 17px', // same as TextField
//                     borderRadius: '12px'
//                   }
//                 }}
//               >
//                 <MenuItem value="" disabled>
//                   <Typography sx={{ color: '#9CA3AF' }}>Select a game</Typography>
//                 </MenuItem>
//                 {gamesData.map((game) => (
//                   <MenuItem key={game.id} value={game.id}>
//                     {game.game_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>

//           {gameSelection && (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Name *
//               </Typography>

//               {leagueNameType === 'dropdown' ? (
//                 // Dropdown for Football
//                 <>
//                   {/* <FormControl fullWidth>
//                   <Select
//                     value={leagueName}
//                     onChange={(e) => handleLeagueSelection(e.target.value)}
//                     displayEmpty
//                     disabled={isUploading || isLoadingLeagues}
//                     MenuProps={{
//                       PaperProps: {
//                         style: {
//                           maxHeight: 200,
//                         },
//                       },
//                       anchorOrigin: {
//                         vertical: "bottom",
//                         horizontal: "left"
//                       },
//                       transformOrigin: {
//                         vertical: "top",
//                         horizontal: "left"
//                       },
//                       getContentAnchorEl: null,
//                     }}
//                     sx={{
//                       borderRadius: '8px',
//                       '& .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#3C50E0',
//                       },
//                     }}
//                     inputProps={{
//                         sx: {
//                           padding: '10px 17px', // same as TextField
//                           borderRadius: '12px'
//                         }
//                       }}
//                   >
//                     <MenuItem value="" disabled>
//                       {isLoadingLeagues ? (
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <CircularProgress size={16} />
//                           <Typography sx={{ color: '#9CA3AF' }}>Loading leagues...</Typography>
//                         </Box>
//                       ) : (
//                         <Typography sx={{ color: '#9CA3AF' }}>Select a league</Typography>
//                       )}
//                     </MenuItem>
//                     {availableLeagues.map((league) => (
//                       <MenuItem key={league.id} value={league.name}>
//                         {league.name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl> */}
//                   <Autocomplete
//                     fullWidth
//                     disabled={isUploading || isLoadingLeagues}
//                     options={availableLeagues}
//                     getOptionLabel={(option) => option.name}
//                     value={availableLeagues.find(league => league.name === leagueName) || null}
//                     onChange={(event, newValue) => {
//                       if (newValue) handleLeagueSelection(newValue.name);
//                     }}
//                     loading={isLoadingLeagues}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         placeholder="Search and select a league"
//                         InputProps={{
//                           ...params.InputProps,
//                           endAdornment: (
//                             <>
//                               {isLoadingLeagues ? <CircularProgress size={20} /> : null}
//                               {params.InputProps.endAdornment}
//                             </>
//                           ),
//                         }}
//                         sx={{
//                           '& .MuiOutlinedInput-root': {
//                             borderRadius: '8px',
//                             '& fieldset': {
//                               borderColor: '#D1D5DB',
//                             },
//                             '&:hover fieldset': {
//                               borderColor: '#9CA3AF',
//                             },
//                             '&.Mui-focused fieldset': {
//                               borderColor: '#3C50E0',
//                             },
//                           },
//                           '& .MuiInputBase-input': {
//                             padding: '12px 14px',
//                             fontSize: '14px'
//                           }
//                         }}
//                       />
//                     )}
//                   />
//                 </>
//               ) : (
//                 // Text field for other games
//                 <TextField
//                   fullWidth
//                   placeholder="Enter the league name"
//                   value={leagueName}
//                   onChange={(e) => setLeagueName(e.target.value)}
//                   disabled={isUploading}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: '8px',
//                       '& fieldset': {
//                         borderColor: '#D1D5DB',
//                       },
//                       '&:hover fieldset': {
//                         borderColor: '#9CA3AF',
//                       },
//                       '&.Mui-focused fieldset': {
//                         borderColor: '#3C50E0',
//                       },
//                     },
//                     '& .MuiInputBase-input': {
//                       padding: '12px 14px',
//                       fontSize: '14px'
//                     }
//                   }}
//                 />
//               )}
//             </Box>
//           )}

//           {/* Logo Upload Section - Shown for all games, but upload disabled for football */}
//           {gameSelection && (
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 League Logo {isFootballGame ? '' : '(Optional)'}
//               </Typography>

//               <Box
//                 sx={{
//                   border: isFootballGame ? '2px solid #E5E7EB' : '2px dashed #D1D5DB',
//                   borderRadius: '8px',
//                   p: 4,
//                   textAlign: 'center',
//                   cursor: (isUploading || isFootballGame) ? 'not-allowed' : 'pointer',
//                   transition: 'all 0.2s',
//                   opacity: isUploading ? 0.6 : 1,
//                   backgroundColor: isFootballGame ? '#F9FAFB' : 'transparent',
//                   '&:hover': !isUploading && !isFootballGame && {
//                     borderColor: '#9CA3AF',
//                     backgroundColor: '#F9FAFB'
//                   }
//                 }}
//                 onClick={() => !isUploading && !isFootballGame && document.getElementById('league-logo-upload').click()}
//               >
//                 {isUploading ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       Uploading image...
//                     </Typography>
//                   </Box>
//                 ) : logoPreview ? (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <img
//                       src={logoPreview}
//                       alt="League logo preview"
//                       style={{
//                         width: '60px',
//                         height: '60px',
//                         objectFit: 'cover',
//                         borderRadius: '8px'
//                       }}
//                     />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
//                       {isFootballGame
//                         ? 'Official league logo'
//                         : 'Click to change logo'
//                       }
//                     </Typography>
//                   </Box>
//                 ) : (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                     <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
//                     <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                       {isFootballGame
//                         ? 'League logo will be loaded automatically'
//                         : 'Click to upload league logo'
//                       }
//                     </Typography>
//                     {!isFootballGame && (
//                       <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
//                         PNG, JPG, GIF up to 10MB
//                       </Typography>
//                     )}
//                   </Box>
//                 )}

//                 {!isFootballGame && (
//                   <input
//                     id="league-logo-upload"
//                     type="file"
//                     accept="image/*"
//                     onChange={handleFileUpload}
//                     disabled={isUploading}
//                     style={{ display: 'none' }}
//                   />
//                 )}
//               </Box>

//               {/* Error Message - Only show for non-football games */}
//               {uploadError && !isFootballGame && (
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: '#EF4444',
//                     fontSize: '12px',
//                     mt: 1
//                   }}
//                 >
//                   {uploadError}
//                 </Typography>
//               )}
//             </Box>
//           )}
//         </Stack>
//       </DialogContent>

//       <DialogActions
//         sx={{
//           p: 3,
//           borderTop: '1px solid #E5E7EB',
//           justifyContent: 'flex-end',
//           gap: 2
//         }}
//       >
//         <Button
//           onClick={handleCancel}
//           disabled={isUploading}
//           sx={{
//             color: '#6B7280',
//             backgroundColor: 'transparent',
//             border: 'none',
//             '&:hover': {
//               backgroundColor: '#F9FAFB'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 500,
//             px: 3
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           onClick={handleSave}
//           disabled={!isFormValid}
//           sx={{
//             backgroundColor: '#3C50E0',
//             color: '#fff',
//             '&:hover': { backgroundColor: '#2F4BCE' },
//             '&:disabled': {
//               backgroundColor: '#D1D5DB',
//               color: '#9CA3AF'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 600,
//             px: 3,
//             minWidth: '80px'
//           }}
//         >
//           {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

//Notification Error Message Fixed
// const CreateNewLeagueModal = ({ open, onClose, onSave, selectedGame, gamesData, onRefreshLeagues }) => {
//   const [gameSelection, setGameSelection] = useState(selectedGame || '');
//   const [leagueName, setLeagueName] = useState('');
//   const [leagueNameType, setLeagueNameType] = useState('text'); // 'text' or 'dropdown'
//   const [availableLeagues, setAvailableLeagues] = useState([]);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreview, setLogoPreview] = useState('');
//   const [selectedLeagueData, setSelectedLeagueData] = useState(null); // New state for selected league data
//   const [isUploading, setIsUploading] = useState(false);
//   const [isLoadingLeagues, setIsLoadingLeagues] = useState(false);
//   const [uploadError, setUploadError] = useState('');
  
//   // Add notification states
//   const [showNotification, setShowNotification] = useState(false);
//   const [notificationMessage, setNotificationMessage] = useState('');

//   useEffect(() => {
//     if (open) {
//       const initialGameSelection = selectedGame || '';
//       setGameSelection(initialGameSelection);
//       setLeagueName('');
//       setLeagueNameType('text');
//       setAvailableLeagues([]);
//       setLogoFile(null);
//       setLogoPreview('');
//       setSelectedLeagueData(null); // Reset selected league data
//       setIsUploading(false);
//       setIsLoadingLeagues(false);
//       setUploadError('');
//       // Reset notification states
//       setShowNotification(false);
//       setNotificationMessage('');

//       const selectedGameData = gamesData.find(game => game.id === initialGameSelection);
//       if (selectedGameData?.game_name.toLowerCase() === 'football') {
//         setLeagueNameType('dropdown');
//         fetchAvailableLeagues();
//       }
//     }
//   }, [open, selectedGame, gamesData]);

//   // Get selected game object to access game name
//   const selectedGameObj = gamesData.find(game => game.id === gameSelection);

//   // Fetch leagues when game changes
//   useEffect(() => {
//     if (selectedGameObj && selectedGameObj.game_name.toLowerCase() === 'football') {
//       fetchAvailableLeagues();
//       setLeagueNameType('dropdown');
//     } else {
//       setLeagueNameType('text');
//       setAvailableLeagues([]);
//       setSelectedLeagueData(null); // Reset when switching away from football
//     }
//     setLeagueName('');
//     setLogoPreview(''); // Reset logo preview when game changes
//     setLogoFile(null); // Reset logo file when game changes
//   }, [gameSelection, selectedGameObj]);

//   const fetchAvailableLeagues = async () => {
//     setIsLoadingLeagues(true);
//     try {
//       const response = await Axios.get(`${base_url}/api/pot/leagues`, Config);
//       console.log(response, "response111");
//       let leaquename = response?.data?.data.map((item) => {
//         return {
//           ...item,
//           id: item?.league_id,
//           name: `${item?.league_name} - ${item?.country}`,
//         }
//       });
//       setAvailableLeagues(leaquename);
//     } catch (error) {
//       console.error('Error fetching leagues:', error);
//       setUploadError('Failed to load leagues. Please try again.');
//     } finally {
//       setIsLoadingLeagues(false);
//     }
//   };

//   // Handle league selection for football
//   const handleLeagueSelection = (selectedLeagueName) => {
//     setLeagueName(selectedLeagueName);

//     // Find the selected league data
//     const selectedLeague = availableLeagues.find(league => league.name === selectedLeagueName);
//     if (selectedLeague) {
//       setSelectedLeagueData(selectedLeague);
//       // Set the logo preview to the league's logo URL
//       if (selectedLeague.logo) {
//         setLogoPreview(selectedLeague.logo);
//         setLogoFile(null); // Clear any uploaded file since we're using the API logo
//       }
//     }
//   };

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.startsWith('image/')) {
//         setUploadError('Please select an image file');
//         return;
//       }

//       // Validate file size (10MB limit)
//       if (file.size > 10 * 1024 * 1024) {
//         setUploadError('File size should be less than 10MB');
//         return;
//       }

//       setUploadError('');
//       setLogoFile(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setLogoPreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSave = async (shouldRefresh = false) => {
//     if (!gameSelection) {
//       setUploadError('Please select a game');
//       return;
//     }

//     if (!leagueName.trim()) {
//       setUploadError('League name is required');
//       return;
//     }

//     setIsUploading(true);
//     setUploadError('');

//     try {
//       let firebaseImageUrl = '';

//       // For football leagues, always use the API logo URL (no custom upload allowed)
//       if (selectedGameObj?.game_name.toLowerCase() === 'football' && selectedLeagueData?.logo) {
//         firebaseImageUrl = selectedLeagueData.logo;
//       } else if (logoFile && selectedGameObj?.game_name.toLowerCase() !== 'football') {
//         // Upload custom image to Firebase only for non-football games
//         const uploadResult = await FirebaseImageUpload(logoFile);
//         // Remove query parameters from Firebase URL as done in CreateNewGameModal
//         firebaseImageUrl = uploadResult.split('&')[0];
//       }

//       // Prepare payload with game ID (not game name)
//       const leaguePayload = {
//         name: leagueName.trim(),
//         game: gameSelection, // This is now the game ID
//         is_system_league: false,
//         is_active: false,
//         logo_url: firebaseImageUrl || '',
//         // Include additional league data for football leagues
//         ...(selectedLeagueData && {
//           system_league_id: selectedLeagueData.system_league_id,
//           country: selectedLeagueData.country,
//           type: selectedLeagueData.type
//         })
//       };

//       // Call API to create league
//       const response = await Axios.post(
//         `${base_url}/api/pot/preferredleagues/`,
//         leaguePayload,
//         Config
//       );

//       if (response.data) {
//         // Create local league object for UI update
//         const newLeague = {
//           id: response.data.id || Date.now(),
//           name: leagueName.trim(),
//           game_id: gameSelection,
//           logo: firebaseImageUrl || '/api/placeholder/40/40',
//           shortName: leagueName.trim().substring(0, 3).toUpperCase(),
//           type: selectedLeagueData?.type || 'Manual',
//           isSelected: true,
//           ...response.data // Include any additional data from API response
//         };

//         const selectedGameObj = gamesData.find(game => game.id === gameSelection);
//         onSave(newLeague, selectedGameObj?.game_name);
//         handleCancel();
//         console.log('League created successfully:', response.data);
//         if (shouldRefresh && onRefreshLeagues) {
//           onRefreshLeagues();
//         }
//       }
//     } catch (error) {
//       console.error('Error creating league:', error);
      
//       // Handle API validation errors and show notification
//       if (error.response?.data) {
//         const errorData = error.response.data;
//         let errorMessage = 'Failed to create league. Please try again.';
        
//         // Check if it's a validation error with field-specific messages
//         if (typeof errorData === 'object' && errorData.name) {
//           // Handle name field errors (array format)
//           if (Array.isArray(errorData.name)) {
//             errorMessage = errorData.name[0]; // Display first error message
//           } else {
//             errorMessage = errorData.name;
//           }
//         } else if (errorData.detail) {
//           // Handle general detail error messages
//           errorMessage = errorData.detail;
//         } else if (errorData.message) {
//           // Handle general message error
//           errorMessage = errorData.message;
//         } else if (typeof errorData === 'string') {
//           // Handle string error responses
//           errorMessage = errorData;
//         }
        
//         // Show notification instead of setting uploadError
//         setNotificationMessage(errorMessage);
//         setShowNotification(true);
//       } else if (error.message) {
//         setNotificationMessage(error.message);
//         setShowNotification(true);
//       } else {
//         setNotificationMessage('Failed to create league. Please try again.');
//         setShowNotification(true);
//       }
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handleCancel = () => {
//     setGameSelection(selectedGame || '');
//     setLeagueName('');
//     setLeagueNameType('text');
//     setAvailableLeagues([]);
//     setLogoFile(null);
//     setLogoPreview('');
//     setSelectedLeagueData(null);
//     setIsUploading(false);
//     setIsLoadingLeagues(false);
//     setUploadError('');
//     // Reset notification states
//     setShowNotification(false);
//     setNotificationMessage('');
//     onClose();
//   };

//   const isFormValid = gameSelection && leagueName.trim() && !isUploading && !isLoadingLeagues;

//   // Check if current game is football
//   const isFootballGame = selectedGameObj?.game_name.toLowerCase() === 'football';

//   return (
//     <>
//       {/* Notification Component */}
//       <Notification 
//         show={showNotification}
//         type="error"
//         message={notificationMessage}
//         setopen={setShowNotification}
//       />
      
//       <Dialog
//         open={open}
//         onClose={handleCancel}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: '12px',
//             maxWidth: '500px'
//           }
//         }}
//       >
//         <DialogTitle sx={{ p: 0 }}>
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               p: 3,
//               borderBottom: '1px solid #E5E7EB'
//             }}
//           >
//             <Typography
//               variant="h6"
//               sx={{
//                 fontWeight: 600,
//                 fontSize: '18px',
//                 color: '#1F2937'
//               }}
//             >
//               Create a new league
//             </Typography>
//             <IconButton
//               onClick={handleCancel}
//               disabled={isUploading}
//               sx={{
//                 color: '#6B7280',
//                 '&:hover': { backgroundColor: '#F3F4F6' }
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>

//         <DialogContent sx={{ p: 3 }}>
//           <Stack spacing={3}>
//             {/* Step 1: Game Selection Field */}
//             <Box>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#374151',
//                   fontWeight: 500,
//                   mb: 1
//                 }}
//               >
//                 Which sport does it belong to *
//               </Typography>
//               <FormControl fullWidth>
//                 <Select
//                   value={gameSelection}
//                   onChange={(e) => setGameSelection(e.target.value)}
//                   displayEmpty
//                   disabled={isUploading}
//                   MenuProps={{
//                     PaperProps: {
//                       style: {
//                         maxHeight: 200,
//                       },
//                     },
//                     anchorOrigin: {
//                       vertical: "bottom",
//                       horizontal: "left"
//                     },
//                     transformOrigin: {
//                       vertical: "top",
//                       horizontal: "left"
//                     },
//                     getContentAnchorEl: null,
//                   }}
//                   sx={{
//                     borderRadius: '8px',
//                     '& .MuiOutlinedInput-notchedOutline': {
//                       borderColor: '#D1D5DB',
//                     },
//                     '&:hover .MuiOutlinedInput-notchedOutline': {
//                       borderColor: '#9CA3AF',
//                     },
//                     '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                       borderColor: '#3C50E0',
//                     },
//                   }}
//                   inputProps={{
//                     sx: {
//                       padding: '10px 17px', // same as TextField
//                       borderRadius: '12px'
//                     }
//                   }}
//                 >
//                   <MenuItem value="" disabled>
//                     <Typography sx={{ color: '#9CA3AF' }}>Select a game</Typography>
//                   </MenuItem>
//                   {gamesData.map((game) => (
//                     <MenuItem key={game.id} value={game.id}>
//                       {game.game_name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>

//             {gameSelection && (
//               <Box>
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: '#374151',
//                     fontWeight: 500,
//                     mb: 1
//                   }}
//                 >
//                   League Name *
//                 </Typography>

//                 {leagueNameType === 'dropdown' ? (
//                   // Dropdown for Football
//                   <>
//                     <Autocomplete
//                       fullWidth
//                       disabled={isUploading || isLoadingLeagues}
//                       options={availableLeagues}
//                       getOptionLabel={(option) => option.name}
//                       value={availableLeagues.find(league => league.name === leagueName) || null}
//                       onChange={(event, newValue) => {
//                         if (newValue) handleLeagueSelection(newValue.name);
//                       }}
//                       loading={isLoadingLeagues}
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           placeholder="Search and select a league"
//                           InputProps={{
//                             ...params.InputProps,
//                             endAdornment: (
//                               <>
//                                 {isLoadingLeagues ? <CircularProgress size={20} /> : null}
//                                 {params.InputProps.endAdornment}
//                               </>
//                             ),
//                           }}
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               borderRadius: '8px',
//                               '& fieldset': {
//                                 borderColor: '#D1D5DB',
//                               },
//                               '&:hover fieldset': {
//                                 borderColor: '#9CA3AF',
//                               },
//                               '&.Mui-focused fieldset': {
//                                 borderColor: '#3C50E0',
//                               },
//                             },
//                             '& .MuiInputBase-input': {
//                               padding: '12px 14px',
//                               fontSize: '14px'
//                             }
//                           }}
//                         />
//                       )}
//                     />
//                   </>
//                 ) : (
//                   // Text field for other games
//                   <TextField
//                     fullWidth
//                     placeholder="Enter the league name"
//                     value={leagueName}
//                     onChange={(e) => setLeagueName(e.target.value)}
//                     disabled={isUploading}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: '8px',
//                         '& fieldset': {
//                           borderColor: '#D1D5DB',
//                         },
//                         '&:hover fieldset': {
//                           borderColor: '#9CA3AF',
//                         },
//                         '&.Mui-focused fieldset': {
//                           borderColor: '#3C50E0',
//                         },
//                       },
//                       '& .MuiInputBase-input': {
//                         padding: '12px 14px',
//                         fontSize: '14px'
//                       }
//                     }}
//                   />
//                 )}
//               </Box>
//             )}

//             {/* Logo Upload Section - Shown for all games, but upload disabled for football */}
//             {gameSelection && (
//               <Box>
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: '#374151',
//                     fontWeight: 500,
//                     mb: 1
//                   }}
//                 >
//                   League Logo {isFootballGame ? '' : '(Optional)'}
//                 </Typography>

//                 <Box
//                   sx={{
//                     border: isFootballGame ? '2px solid #E5E7EB' : '2px dashed #D1D5DB',
//                     borderRadius: '8px',
//                     p: 4,
//                     textAlign: 'center',
//                     cursor: (isUploading || isFootballGame) ? 'not-allowed' : 'pointer',
//                     transition: 'all 0.2s',
//                     opacity: isUploading ? 0.6 : 1,
//                     backgroundColor: isFootballGame ? '#F9FAFB' : 'transparent',
//                     '&:hover': !isUploading && !isFootballGame && {
//                       borderColor: '#9CA3AF',
//                       backgroundColor: '#F9FAFB'
//                     }
//                   }}
//                   onClick={() => !isUploading && !isFootballGame && document.getElementById('league-logo-upload').click()}
//                 >
//                   {isUploading ? (
//                     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                       <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
//                       <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                         Uploading image...
//                       </Typography>
//                     </Box>
//                   ) : logoPreview ? (
//                     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                       <img
//                         src={logoPreview}
//                         alt="League logo preview"
//                         style={{
//                           width: '60px',
//                           height: '60px',
//                           objectFit: 'cover',
//                           borderRadius: '8px'
//                         }}
//                       />
//                       <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
//                         {isFootballGame
//                           ? 'Official league logo'
//                           : 'Click to change logo'
//                         }
//                       </Typography>
//                     </Box>
//                   ) : (
//                     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                       <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
//                       <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                         {isFootballGame
//                           ? 'League logo will be loaded automatically'
//                           : 'Click to upload league logo'
//                         }
//                       </Typography>
//                       {!isFootballGame && (
//                         <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
//                           PNG, JPG, GIF up to 10MB
//                         </Typography>
//                       )}
//                     </Box>
//                   )}

//                   {!isFootballGame && (
//                     <input
//                       id="league-logo-upload"
//                       type="file"
//                       accept="image/*"
//                       onChange={handleFileUpload}
//                       disabled={isUploading}
//                       style={{ display: 'none' }}
//                     />
//                   )}
//                 </Box>

//                 {/* Error Message - Only show for non-football games and non-API errors */}
//                 {uploadError && !isFootballGame && (
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: '#EF4444',
//                       fontSize: '12px',
//                       mt: 1
//                     }}
//                   >
//                     {uploadError}
//                   </Typography>
//                 )}
//               </Box>
//             )}
//           </Stack>
//         </DialogContent>

//         <DialogActions
//           sx={{
//             p: 3,
//             borderTop: '1px solid #E5E7EB',
//             justifyContent: 'flex-end',
//             gap: 2
//           }}
//         >
//           <Button
//             onClick={handleCancel}
//             disabled={isUploading}
//             sx={{
//               color: '#6B7280',
//               backgroundColor: 'transparent',
//               border: 'none',
//               '&:hover': {
//                 backgroundColor: '#F9FAFB'
//               },
//               borderRadius: '8px',
//               textTransform: 'none',
//               fontWeight: 500,
//               px: 3
//             }}
//           >
//             Cancel
//           </Button>

//           <Button
//             onClick={handleSave}
//             disabled={!isFormValid}
//             sx={{
//               backgroundColor: '#3C50E0',
//               color: '#fff',
//               '&:hover': { backgroundColor: '#2F4BCE' },
//               '&:disabled': {
//                 backgroundColor: '#D1D5DB',
//                 color: '#9CA3AF'
//               },
//               borderRadius: '8px',
//               textTransform: 'none',
//               fontWeight: 600,
//               px: 3,
//               minWidth: '80px'
//             }}
//           >
//             {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

const CreateNewLeagueModal = ({ open, onClose, onSave, selectedGame, gamesData, onRefreshLeagues }) => {
  const [gameSelection, setGameSelection] = useState(selectedGame || '');
  const [leagueName, setLeagueName] = useState('');
  const [leagueNameType, setLeagueNameType] = useState('text'); // 'text' or 'dropdown'
  const [availableLeagues, setAvailableLeagues] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState('');
  const [selectedLeagueData, setSelectedLeagueData] = useState(null); // New state for selected league data
  const [isUploading, setIsUploading] = useState(false);
  const [isLoadingLeagues, setIsLoadingLeagues] = useState(false);
  const [uploadError, setUploadError] = useState('');
  
  // Add notification states
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  useEffect(() => {
    if (open) {
      const initialGameSelection = selectedGame || '';
      setGameSelection(initialGameSelection);
      setLeagueName('');
      setLeagueNameType('text');
      setAvailableLeagues([]);
      setLogoFile(null);
      setLogoPreview('');
      setSelectedLeagueData(null); // Reset selected league data
      setIsUploading(false);
      setIsLoadingLeagues(false);
      setUploadError('');
      // Reset notification states
      setShowNotification(false);
      setNotificationMessage('');

      const selectedGameData = gamesData.find(game => game.id === initialGameSelection);
      if (selectedGameData?.game_name.toLowerCase() === 'football') {
        setLeagueNameType('dropdown');
        fetchAvailableLeagues();
      }
    }
  }, [open, selectedGame, gamesData]);

  // Get selected game object to access game name
  const selectedGameObj = gamesData.find(game => game.id === gameSelection);

  // Fetch leagues when game changes
  useEffect(() => {
    if (selectedGameObj && selectedGameObj.game_name.toLowerCase() === 'football') {
      fetchAvailableLeagues();
      setLeagueNameType('dropdown');
    } else {
      setLeagueNameType('text');
      setAvailableLeagues([]);
      setSelectedLeagueData(null); // Reset when switching away from football
    }
    setLeagueName('');
    setLogoPreview(''); // Reset logo preview when game changes
    setLogoFile(null); // Reset logo file when game changes
  }, [gameSelection, selectedGameObj]);

  const fetchAvailableLeagues = async () => {
    setIsLoadingLeagues(true);
    try {
      const response = await Axios.get(`${base_url}/api/pot/leagues`, Config);
      console.log(response, "response111");
      let leaquename = response?.data?.data.map((item) => {
        return {
          ...item,
          id: item?.league_id,
          name: `${item?.league_name} - ${item?.country}`,
        }
      });
      setAvailableLeagues(leaquename);
    } catch (error) {
      console.error('Error fetching leagues:', error);
      setUploadError('Failed to load leagues. Please try again.');
    } finally {
      setIsLoadingLeagues(false);
    }
  };

  // Handle league selection for football
  const handleLeagueSelection = (selectedLeagueName) => {
    setLeagueName(selectedLeagueName);

    // Find the selected league data
    const selectedLeague = availableLeagues.find(league => league.name === selectedLeagueName);
    if (selectedLeague) {
      setSelectedLeagueData(selectedLeague);
      // Set the logo preview to the league's logo URL
      if (selectedLeague.logo) {
        setLogoPreview(selectedLeague.logo);
        setLogoFile(null); // Clear any uploaded file since we're using the API logo
      }
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        setUploadError('Please select an image file');
        return;
      }

      // Validate file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        setUploadError('File size should be less than 10MB');
        return;
      }

      // Create an image element to check dimensions
      const img = new Image();
      const reader = new FileReader();
      
      reader.onload = (e) => {
        img.onload = () => {
          // Check image dimensions
          if (img.width > 100 || img.height > 100) {
            setUploadError(`Image dimensions should not exceed 100x100 pixels. Current size: ${img.width}x${img.height}px`);
            // Clear the file input
            event.target.value = '';
            return;
          }
          
          // If all validations pass, set the file and preview
          setUploadError('');
          setLogoFile(file);
          setLogoPreview(e.target.result);
        };
        
        img.onerror = () => {
          setUploadError('Failed to load image. Please try another file.');
          event.target.value = '';
        };
        
        img.src = e.target.result;
      };
      
      reader.onerror = () => {
        setUploadError('Failed to read file. Please try again.');
        event.target.value = '';
      };
      
      reader.readAsDataURL(file);
    }
  };

  const handleSave = async (shouldRefresh = false) => {
    if (!gameSelection) {
      setUploadError('Please select a game');
      return;
    }

    if (!leagueName.trim()) {
      setUploadError('League name is required');
      return;
    }

    setIsUploading(true);
    setUploadError('');

    try {
      let firebaseImageUrl = '';

      // For football leagues, always use the API logo URL (no custom upload allowed)
      if (selectedGameObj?.game_name.toLowerCase() === 'football' && selectedLeagueData?.logo) {
        firebaseImageUrl = selectedLeagueData.logo;
      } else if (logoFile && selectedGameObj?.game_name.toLowerCase() !== 'football') {
        // Upload custom image to Firebase only for non-football games
        const uploadResult = await FirebaseImageUpload(logoFile);
        // Remove query parameters from Firebase URL as done in CreateNewGameModal
        firebaseImageUrl = uploadResult.split('&')[0];
      }

      // Prepare payload with game ID (not game name)
      const leaguePayload = {
        name: leagueName.trim(),
        game: gameSelection, // This is now the game ID
        is_system_league: false,
        is_active: false,
        logo_url: firebaseImageUrl || '',
        // Include additional league data for football leagues
        ...(selectedLeagueData && {
          system_league_id: selectedLeagueData.system_league_id,
          country: selectedLeagueData.country,
          type: selectedLeagueData.type
        })
      };

      // Call API to create league
      const response = await Axios.post(
        `${base_url}/api/pot/preferredleagues/`,
        leaguePayload,
        Config
      );

      if (response.data) {
        // Create local league object for UI update
        const newLeague = {
          id: response.data.id || Date.now(),
          name: leagueName.trim(),
          game_id: gameSelection,
          logo: firebaseImageUrl || '/api/placeholder/40/40',
          shortName: leagueName.trim().substring(0, 3).toUpperCase(),
          type: selectedLeagueData?.type || 'Manual',
          isSelected: true,
          ...response.data // Include any additional data from API response
        };

        const selectedGameObj = gamesData.find(game => game.id === gameSelection);
        onSave(newLeague, selectedGameObj?.game_name);
        handleCancel();
        console.log('League created successfully:', response.data);
        if (shouldRefresh && onRefreshLeagues) {
          onRefreshLeagues();
        }
      }
    } catch (error) {
      console.error('Error creating league:', error);
      
      // Handle API validation errors and show notification
      if (error.response?.data) {
        const errorData = error.response.data;
        let errorMessage = 'Failed to create league. Please try again.';
        
        // Check if it's a validation error with field-specific messages
        if (typeof errorData === 'object' && errorData.name) {
          // Handle name field errors (array format)
          if (Array.isArray(errorData.name)) {
            errorMessage = errorData.name[0]; // Display first error message
          } else {
            errorMessage = errorData.name;
          }
        } else if (errorData.detail) {
          // Handle general detail error messages
          errorMessage = errorData.detail;
        } else if (errorData.message) {
          // Handle general message error
          errorMessage = errorData.message;
        } else if (typeof errorData === 'string') {
          // Handle string error responses
          errorMessage = errorData;
        }
        
        // Show notification instead of setting uploadError
        // setNotificationMessage(errorMessage);
        setNotificationMessage("League Already Exits");
        setShowNotification(true);
      } else if (error.message) {
        setNotificationMessage(error.message);
        setShowNotification(true);
      } else {
        setNotificationMessage('Failed to create league. Please try again.');
        setShowNotification(true);
      }
    } finally {
      setIsUploading(false);
    }
  };

  const handleCancel = () => {
    setGameSelection(selectedGame || '');
    setLeagueName('');
    setLeagueNameType('text');
    setAvailableLeagues([]);
    setLogoFile(null);
    setLogoPreview('');
    setSelectedLeagueData(null);
    setIsUploading(false);
    setIsLoadingLeagues(false);
    setUploadError('');
    // Reset notification states
    setShowNotification(false);
    setNotificationMessage('');
    onClose();
  };

  const isFormValid = gameSelection && leagueName.trim() && !isUploading && !isLoadingLeagues;

  // Check if current game is football
  const isFootballGame = selectedGameObj?.game_name.toLowerCase() === 'football';

  return (
    <>
      {/* Notification Component */}
      <Notification 
        show={showNotification}
        type="error"
        message={notificationMessage}
        setopen={setShowNotification}
      />
      
      <Dialog
        open={open}
        onClose={handleCancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            maxWidth: '500px'
          }
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 3,
              borderBottom: '1px solid #E5E7EB'
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: '#1F2937'
              }}
            >
              Create a new league
            </Typography>
            <IconButton
              onClick={handleCancel}
              disabled={isUploading}
              sx={{
                color: '#6B7280',
                '&:hover': { backgroundColor: '#F3F4F6' }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Stack spacing={3}>
            {/* Step 1: Game Selection Field */}
            <Box>
              <Typography
                variant="body2"
                sx={{
                  color: '#374151',
                  fontWeight: 500,
                  mb: 1
                }}
              >
                Which sport does it belong to *
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={gameSelection}
                  onChange={(e) => setGameSelection(e.target.value)}
                  displayEmpty
                  disabled={isUploading}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                      },
                    },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null,
                  }}
                  sx={{
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#D1D5DB',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#9CA3AF',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3C50E0',
                    },
                  }}
                  inputProps={{
                    sx: {
                      padding: '10px 17px', // same as TextField
                      borderRadius: '12px'
                    }
                  }}
                >
                  <MenuItem value="" disabled>
                    <Typography sx={{ color: '#9CA3AF' }}>Select a game</Typography>
                  </MenuItem>
                  {gamesData.map((game) => (
                    <MenuItem key={game.id} value={game.id}>
                      {game.game_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {gameSelection && (
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#374151',
                    fontWeight: 500,
                    mb: 1
                  }}
                >
                  League Name *
                </Typography>

                {leagueNameType === 'dropdown' ? (
                  // Dropdown for Football
                  <>
                    <Autocomplete
                      fullWidth
                      disabled={isUploading || isLoadingLeagues}
                      options={availableLeagues}
                      getOptionLabel={(option) => option.name}
                      value={availableLeagues.find(league => league.name === leagueName) || null}
                      onChange={(event, newValue) => {
                        if (newValue) handleLeagueSelection(newValue.name);
                      }}
                      loading={isLoadingLeagues}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search and select a league"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {isLoadingLeagues ? <CircularProgress size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              '& fieldset': {
                                borderColor: '#D1D5DB',
                              },
                              '&:hover fieldset': {
                                borderColor: '#9CA3AF',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#3C50E0',
                              },
                            },
                            '& .MuiInputBase-input': {
                              padding: '12px 14px',
                              fontSize: '14px'
                            }
                          }}
                        />
                      )}
                    />
                  </>
                ) : (
                  // Text field for other games
                  <TextField
                    fullWidth
                    placeholder="Enter the league name"
                    value={leagueName}
                    onChange={(e) => setLeagueName(e.target.value)}
                    disabled={isUploading}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        '& fieldset': {
                          borderColor: '#D1D5DB',
                        },
                        '&:hover fieldset': {
                          borderColor: '#9CA3AF',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#3C50E0',
                        },
                      },
                      '& .MuiInputBase-input': {
                        padding: '12px 14px',
                        fontSize: '14px'
                      }
                    }}
                  />
                )}
              </Box>
            )}

            {/* Logo Upload Section - Shown for all games, but upload disabled for football */}
            {gameSelection && (
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#374151',
                    fontWeight: 500,
                    mb: 1
                  }}
                >
                  League Logo {isFootballGame ? '' : '(Optional)'}
                </Typography>

                <Box
                  sx={{
                    border: isFootballGame ? '2px solid #E5E7EB' : '2px dashed #D1D5DB',
                    borderRadius: '8px',
                    p: 4,
                    textAlign: 'center',
                    cursor: (isUploading || isFootballGame) ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s',
                    opacity: isUploading ? 0.6 : 1,
                    backgroundColor: isFootballGame ? '#F9FAFB' : 'transparent',
                    '&:hover': !isUploading && !isFootballGame && {
                      borderColor: '#9CA3AF',
                      backgroundColor: '#F9FAFB'
                    }
                  }}
                  onClick={() => !isUploading && !isFootballGame && document.getElementById('league-logo-upload').click()}
                >
                  {isUploading ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                      <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
                      <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
                        Uploading image...
                      </Typography>
                    </Box>
                  ) : logoPreview ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                      <img
                        src={logoPreview}
                        alt="League logo preview"
                        style={{
                          width: '60px',
                          height: '60px',
                          objectFit: 'cover',
                          borderRadius: '8px'
                        }}
                      />
                      <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
                        {isFootballGame
                          ? 'Official league logo'
                          : 'Click to change logo'
                        }
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                      <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
                      <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
                        {isFootballGame
                          ? 'League logo will be loaded automatically'
                          : 'Click to upload league logo'
                        }
                      </Typography>
                      {!isFootballGame && (
                        <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
                          PNG, JPG, GIF up to 10MB
                        </Typography>
                      )}
                    </Box>
                  )}

                  {!isFootballGame && (
                    <input
                      id="league-logo-upload"
                      type="file"
                      accept="image/*"
                      onChange={handleFileUpload}
                      disabled={isUploading}
                      style={{ display: 'none' }}
                    />
                  )}
                </Box>

                {/* Error Message - Only show for non-football games and non-API errors */}
                {uploadError && !isFootballGame && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#EF4444',
                      fontSize: '12px',
                      mt: 1
                    }}
                  >
                    {uploadError}
                  </Typography>
                )}
              </Box>
            )}
          </Stack>
        </DialogContent>

        <DialogActions
          sx={{
            p: 3,
            borderTop: '1px solid #E5E7EB',
            justifyContent: 'flex-end',
            gap: 2
          }}
        >
          <Button
            onClick={handleCancel}
            disabled={isUploading}
            sx={{
              color: '#6B7280',
              backgroundColor: 'transparent',
              border: 'none',
              '&:hover': {
                backgroundColor: '#F9FAFB'
              },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500,
              px: 3
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleSave}
            disabled={!isFormValid}
            sx={{
              backgroundColor: '#3C50E0',
              color: '#fff',
              '&:hover': { backgroundColor: '#2F4BCE' },
              '&:disabled': {
                backgroundColor: '#D1D5DB',
                color: '#9CA3AF'
              },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              minWidth: '80px'
            }}
          >
            {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const LeaguesModal = ({ open, onClose, onSave, currentLeagues, currentGames, onRefreshLeagues }) => {
  const [selectedGame, setSelectedGame] = useState('Football');
  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [createNewLeagueOpen, setCreateNewLeagueOpen] = useState(false);
  const [processedLeaguesData, setProcessedLeaguesData] = useState({});
  const [editLeagueOpen, setEditLeagueOpen] = useState(false);
  const [editLeagueData, setEditLeagueData] = useState(null);
  // console.log(currentLeagues, "currentLeagues");
  // console.log(currentGames, "currentGames");
  // Process API data when component mounts or props change
  // useEffect(() => {
  //   if (currentLeagues && currentGames) {
  //     // Group leagues by game_id
  //     const leaguesByGame = {};

  //     // Initialize each game with empty array
  //     currentGames.forEach(game => {
  //       leaguesByGame[game.game_name] = [];
  //     });

  //     // Process leagues and group them by game
  //     currentLeagues.forEach(league => {
  //       // Find the game this league belongs to
  //       const game = currentGames.find(g => g.id === league.game);
  //       console.log(game, "game111")
  //       if (game) {
  //         const processedLeague = {
  //           id: league.id,
  //           name: league.name,
  //           logo: league.logo || '/api/placeholder/40/40',
  //           shortName: league.name.substring(0, 3).toUpperCase(),
  //           type: league.system_league ? 'API' : 'Manual',
  //           isSelected: league.active,
  //           league_id: league.league_id,
  //           configured_league_id: league.configured_league_id,
  //         };
  //         leaguesByGame[game.game_name].push(processedLeague);
  //       }
  //     });

  //     setProcessedLeaguesData(leaguesByGame);

  //     // Set first available game as selected if not already set
  //     if (!selectedGame && currentGames.length > 0) {
  //       console.log('Setting initial selected game:', currentGames[0]);
  //       setSelectedGame(currentGames[0].id);
  //     }
  //   }
  // }, [currentLeagues, currentGames, selectedGame]);

  const [deletePopup, setDeletePopup] = useState(false);
  const [leagueToDelete, setLeagueToDelete] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState('');

  useEffect(() => {
    if (currentLeagues && currentGames) {
      const leaguesByGame = {};

      currentGames.forEach(game => {
        leaguesByGame[game.game_name] = [];
      });
      console.log(currentLeagues, "currentLeagues111");
      currentLeagues.forEach(league => {
        const game = currentGames.find(g => g.id === league.game);
        console.log(game, "gameFetchEach")
        if (game) {
          const processedLeague = {
            id: league.id,
            name: league.name,
            logo: league.logo_url || '/api/placeholder/40/40',
            shortName: league.name.substring(0, 3).toUpperCase(),
            type: league.is_system_league ? 'API' : 'Manual',
            isSelected: league.is_active,
            league_id: league.league_id || null,
            configured_league_id: league.configured_league_id || null,
          };

          leaguesByGame[game.game_name].push(processedLeague);
        }
      });
      console.log(leaguesByGame, "leaguesByGame")
      setProcessedLeaguesData(leaguesByGame);

      if (!selectedGame && currentGames.length > 0) {
        console.log('Setting initial selected game:', currentGames[0]);
        setSelectedGame(currentGames[0].id);
      }
    }
  }, [currentLeagues, currentGames, selectedGame]);

  //console.log('Processed leagues data:', currentGames);

  // Initialize selected leagues based on current data
  useEffect(() => {
    if (open && processedLeaguesData) {
      const initialSelected = [];
      Object.keys(processedLeaguesData).forEach(game => {
        processedLeaguesData[game].forEach(league => {
          if (league.isSelected) {
            initialSelected.push(league.id);
          }
        });
      });
      setSelectedLeagues(initialSelected);
    }
  }, [open, processedLeaguesData]);

  const handleGameSelect = (gameName) => {
    setSelectedGame(gameName);
  };

  const handleLeagueToggle = (leagueId) => {
    setSelectedLeagues(prev => {
      if (prev.includes(leagueId)) {
        return prev.filter(id => id !== leagueId);
      } else {
        return [...prev, leagueId];
      }
    });
  };

  const getCurrentGameId = () => {
    const currentGameObj = currentGames.find(game => game.game_name === selectedGame);
    return currentGameObj ? currentGameObj.id : '';
  };



  // const handleSave = () => {
  //   // Prepare data to save
  //   const updatedLeagues = [];
  //   Object.keys(processedLeaguesData).forEach(game => {
  //     processedLeaguesData[game].forEach(league => {
  //       if (selectedLeagues.includes(league.id)) {
  //         updatedLeagues.push({
  //           ...league,
  //           game: game,
  //           isSelected: true
  //         });
  //       }
  //     });
  //   });

  //   onSave(updatedLeagues);
  //   onClose();
  // };

  //  const handleSave = async () => {
  //   try {
  //     const updatePromises = [];

  //     selectedLeagues.forEach(leagueId => {
  //       const league = currentLeagues.find(l => l.id === leagueId);
  //       if (league) {
  //         const payload = {
  //           name: league.name,
  //           game: league.game,
  //           is_system_league: league.is_system_league,
  //           is_active: true, // Set to true since selected
  //           logo_url: league.logo_url
  //         };
  // console.log(payload, "payload");
  //         const request = Axios.put(
  //           `https://sportspick-zkvkz.ondigitalocean.app/api/pot/preferredleagues/${league.id}/`,
  //           payload,
  //           Config
  //         );

  //         updatePromises.push(request);
  //       }
  //     });
  //     const results = await Promise.all(updatePromises);

  //     console.log('Selected leagues updated successfully.');
  //     if (onSave) {
  //       onSave(results); 
  //     }
  //     if (onClose) {
  //       onClose();
  //     }
  // onRefreshLeagues();
  //     // await Promise.all(updatePromises);

  //     // console.log('Selected leagues updated successfully.');
  //     // onSave?.(); // optional callback
  //     // onClose?.();
  //   } catch (error) {
  //     console.error('Error updating selected leagues:', error);
  //   }
  // };

  // const handleSave = async () => {
  //   try {
  //     // Filter and prepare data for leagues with is_active true (only selected ones)
  //     const selectedLeaguesData = currentLeagues
  //       .filter(league => selectedLeagues.includes(league.id))
  //       .map(league => ({
  //         id: league.id, // Add id here to construct individual request URLs
  //         name: league.name,
  //         game: league.game,
  //         is_system_league: league.is_system_league,
  //         is_active: true, // Set to true since selected
  //         logo_url: league.logo_url
  //       }));

  //     //console.log(selectedLeaguesData, "selectedLeaguesData");

  //     // Loop through and update each league individually
  //     const updatePromises = selectedLeaguesData.map(league =>
  //       Axios.put(
  //         `${base_url}/api/pot/preferredleagues/${league.id}/`,
  //         {
  //           name: league.name,
  //           game: league.game,
  //           is_system_league: league.is_system_league,
  //           is_active: league.is_active,
  //           logo_url: league.logo_url
  //         },
  //         Config
  //       )
  //     );

  //     // Wait for all requests to complete
  //     const results = await Promise.all(updatePromises);

  //     //console.log('All leagues updated:', results);

  //     // Add debugging for callback functions
  //     //console.log('onRefreshLeagues function:', onRefreshLeagues);
  //     //console.log('onClose function:', onClose);

  //     // Call refresh first, then close
  //     if (onRefreshLeagues && typeof onRefreshLeagues === 'function') {
  //       await onRefreshLeagues();
  //       console.log('onRefreshLeagues called successfully');
  //     } else {
  //       console.warn('onRefreshLeagues is not a function or is undefined');
  //     }

  //     if (onClose && typeof onClose === 'function') {
  //       onClose();
  //       console.log('onClose called successfully');
  //     } else {
  //       console.warn('onClose is not a function or is undefined');
  //     }

  //   } catch (error) {
  //     console.error('Error while updating leagues:', error);
  //     // Even if there's an error, try to close the popup
  //     if (onClose && typeof onClose === 'function') {
  //       onClose();
  //     }
  //   }
  // };

  const handleSave = async () => {
    try {
      // Filter leagues that have changed status
      const leaguesToUpdate = currentLeagues.filter(league => {
        const shouldBeActive = selectedLeagues.includes(league.id);
        const currentStatus = league.is_active || false; // Original status from API

        // Only update if the status has changed
        return shouldBeActive !== currentStatus;
      });

      console.log('Leagues to update:', leaguesToUpdate);

      // If no leagues need updating, just close the modal
      if (leaguesToUpdate.length === 0) {
        console.log('No leagues need updating');
        if (onClose && typeof onClose === 'function') {
          onClose();
        }
        return;
      }

      // Prepare update promises for changed leagues only
      const updatePromises = leaguesToUpdate.map(league => {
        const shouldBeActive = selectedLeagues.includes(league.id);

        return Axios.put(
          `${base_url}/api/pot/preferredleagues/${league.id}/`,
          {
            name: league.name,
            game: league.game,
            is_system_league: league.is_system_league,
            is_active: shouldBeActive, // true if selected, false if not selected
            logo_url: league.logo_url
          },
          Config
        );
      });

      // Wait for all requests to complete
      const results = await Promise.all(updatePromises);

      console.log('Changed leagues updated:', results);

      // Call refresh first, then close
      if (onRefreshLeagues && typeof onRefreshLeagues === 'function') {
        await onRefreshLeagues();
        console.log('onRefreshLeagues called successfully');
      } else {
        console.warn('onRefreshLeagues is not a function or is undefined');
      }

      if (onClose && typeof onClose === 'function') {
        onClose();
        console.log('onClose called successfully');
      } else {
        console.warn('onClose is not a function or is undefined');
      }

    } catch (error) {
      console.error('Error while updating leagues:', error);
      // Even if there's an error, try to close the popup
      if (onClose && typeof onClose === 'function') {
        onClose();
      }
    }
  };



  const handleCancel = () => {
    setSelectedGame('Football');
    onClose();
  };

  const handleCreateNewLeague = () => {
    // onClose();
    setCreateNewLeagueOpen(true);
  };

  const handleCreateNewLeagueClose = () => {
    setCreateNewLeagueOpen(false);
  };

  const handleCreateNewLeagueSave = (newLeague, gameNameToRedirect) => {
    // Add the new league to the appropriate game category
    setProcessedLeaguesData(prev => ({
      ...prev,
      [newLeague.game]: [
        ...(prev[newLeague.game] || []),
        newLeague
      ]
    }));

    // Add the new league to selected leagues
    setSelectedLeagues(prev => [...prev, newLeague.id]);

    if (gameNameToRedirect) {
      setSelectedGame(gameNameToRedirect);
    }

    setCreateNewLeagueOpen(false);
    console.log('New league created:', newLeague);
  };

  // const handleEditLeague = (league) => {
  //   console.log('Edit league:', league);
  //   // Handle edit functionality
  // };
  //console.log("currentLeagues", currentLeagues);
  const handleEditLeague = (leagueId) => {
    // console.log('Edit league:', leagueId);
    const leagueToEdit = currentLeagues.find(league => league.id === Number(leagueId));
    //console.log("leagueToEdit", leagueToEdit);
    setEditLeagueData(leagueToEdit);
    setEditLeagueOpen(true);
    //onClose();
  };

  const handleEditLeagueClose = () => {
    setEditLeagueOpen(false);
    setEditLeagueData(null);
  };

  const handleEditLeagueSave = (updatedLeague, gameNameToRedirect) => {
    //console.log('Updated league:', updatedLeague);

    // Update the league in processedLeaguesData
    setProcessedLeaguesData(prev => {
      const newData = { ...prev };
      Object.keys(newData).forEach(game => {
        const leagueIndex = newData[game].findIndex(l => l.id === updatedLeague.id);
        if (leagueIndex !== -1) {
          newData[game][leagueIndex] = {
            ...newData[game][leagueIndex],
            ...updatedLeague
          };
        }
      });
      return newData;
    });

    if (gameNameToRedirect) {
      setSelectedGame(gameNameToRedirect);
    }

    setEditLeagueOpen(false);
    setEditLeagueData(null);
    console.log('League updated successfully:', updatedLeague);
  };

  // const handleDeleteLeague = (league) => {
  //   console.log('Delete league:', league);
  //   // Handle delete functionality
  // };

  //   const handleDeleteLeague = async (league) => {
  //   // Optional: Add confirmation dialog
  //   if (window.confirm(`Are you sure you want to delete the league "${league.name}"?`)) {
  //     try {
  //       // Make DELETE request to API
  //       const response = await Axios.delete(
  //         `https://sportspick-zkvkz.ondigitalocean.app/api/pot/preferredleagues/${league.id}/`,
  //         Config
  //       );

  //       // Check if deletion was successful
  //       if (response.status === 200 || response.status === 204) {
  //         console.log('League deleted successfully');

  //         // Remove the league from local state (processedLeaguesData)
  //         setProcessedLeaguesData(prev => {
  //           const newData = { ...prev };
  //           Object.keys(newData).forEach(game => {
  //             newData[game] = newData[game].filter(l => l.id !== league.id);
  //           });
  //           return newData;
  //         });

  //         // Remove the league from selected leagues
  //         setSelectedLeagues(prev => prev.filter(id => id !== league.id));

  //         // Refresh leagues list (optional - to sync with latest API data)
  //         if (onRefreshLeagues && typeof onRefreshLeagues === 'function') {
  //           onRefreshLeagues();
  //         }
  //       } else {
  //         console.error('Failed to delete league:', response);
  //       }
  //     } catch (error) {
  //       console.error('Error while deleting league:', error);
  //       // Optional: Show error message to user
  //       // You might want to show a toast notification or alert here
  //     }
  //   }
  // };

  // Updated handleDeleteLeague to use ModalPopUp
  const handleDeleteLeague = (league) => {
    setLeagueToDelete(league);
    setDeleteMessage(`Are you sure you want to delete the league "${league.name}"?`);
    setDeletePopup(true);
  };

  // Function to actually delete the league after confirmation
  const confirmDeleteLeague = async () => {
    if (!leagueToDelete) return;

    try {
      const response = await Axios.delete(
        `${base_url}/api/pot/preferredleagues/${leagueToDelete.id}/`,
        Config
      );

      if (response.status === 200 || response.status === 204) {
        console.log('League deleted successfully');

        // Remove the league from local state
        setProcessedLeaguesData(prev => {
          const newData = { ...prev };
          Object.keys(newData).forEach(game => {
            newData[game] = newData[game].filter(l => l.id !== leagueToDelete.id);
          });
          return newData;
        });

        // Remove the league from selected leagues
        setSelectedLeagues(prev => prev.filter(id => id !== leagueToDelete.id));

        // Refresh leagues list
        if (onRefreshLeagues && typeof onRefreshLeagues === 'function') {
          onRefreshLeagues();
        }

        // Close the popup and reset states
        setDeletePopup(false);
        setLeagueToDelete(null);
        setDeleteMessage('');
      } else {
        console.error('Failed to delete league:', response);
      }
    } catch (error) {
      console.error('Error while deleting league:', error);
      // Close the popup even on error
      setDeletePopup(false);
      setLeagueToDelete(null);
      setDeleteMessage('');
    }
  };

  // Function to cancel delete operation
  const cancelDeleteLeague = () => {
    setDeletePopup(false);
    setLeagueToDelete(null);
    setDeleteMessage('');
  };

  const getCurrentGameLeagues = () => {
    return processedLeaguesData[selectedGame] || [];
  };

  console.log(getCurrentGameLeagues(), "getCurrentGameLeagues")

  // Show loading or empty state if no data
  if (!currentGames || currentGames.length === 0) {
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogContent>
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Typography>Loading games data...</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            minHeight: '600px'
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '18px', color: '#1F2937' }}>
            Listing preferred leagues from API
          </Typography>
          <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px', mt: 0.5 }}>
            Selected leagues will be published
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Grid container sx={{ height: '500px' }}>
            {/* Left Sidebar - Games List */}
            <Grid item xs={3} sx={{ borderRight: '1px solid #E5E7EB' }}>
              <List sx={{ p: 1, height: '100%', backgroundColor: "#F6F6F6" }}>
                {currentGames.map((game, index) => (
                  <React.Fragment key={game.id}>
                    <ListItem sx={{ p: 0 }}>
                      <ListItemButton
                        onClick={() => handleGameSelect(game.game_name)}
                        sx={{
                          py: 0.5,
                          px: 1,
                          backgroundColor: selectedGame === game.game_name ? '#3C50E0' : 'transparent',
                          color: selectedGame === game.game_name ? '#fff' : '#1F2937',
                          '&:hover': {
                            backgroundColor: '#3C50E0'
                          },
                          borderRadius: selectedGame === game.game_name ? '3px' : '0px',
                          my: selectedGame === game.game_name ? 0.5 : 0
                        }}
                      >
                        <ListItemText
                          primary={game.game_name}
                          primaryTypographyProps={{
                            fontWeight: selectedGame === game.game_name ? 600 : 400,
                            fontSize: '14px'
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                    {index < currentGames.length - 1 && selectedGame !== game.game_name && selectedGame !== currentGames[index + 1]?.game_name && (
                      <Divider />
                    )}
                  </React.Fragment>
                ))}
              </List>
            </Grid>

            {/* Right Content - Leagues List */}
            <Grid item xs={9} sx={{ p: 3 }}>
              {/* Header with Create New Button */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '16px', color: '#1F2937' }}>
                  {selectedGame} Leagues
                </Typography>
                <TransButton
                  title="Create New League +"
                  onClick={handleCreateNewLeague}
                  sx={{
                    background: "none",
                    border: "1px solid #3C50E0",
                    color: "#3C50E0",
                    '&:hover': {
                      backgroundColor: '#F3F4F6',
                      color: '#3C50E0'
                    }
                  }}
                />
              </Box>

              {/* Leagues List */}
              <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                {getCurrentGameLeagues().map((league) => (
                  <Card
                    key={league.id}
                    sx={{
                      mb: 2,
                      border: '1px solid #E5E7EB',
                      borderRadius: '8px',
                      boxShadow: 'none'
                    }}
                  >
                    <CardContent sx={{ p: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        {/* Left Section - Checkbox, Logo, Name */}
                        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedLeagues.includes(league.id)}
                                onChange={() => handleLeagueToggle(league.id)}
                                sx={{
                                  color: '#D1D5DB',
                                  '&.Mui-checked': {
                                    color: '#3C50E0',
                                  },
                                  mr: 1
                                }}
                              />
                            }
                            label=""
                            sx={{ mr: 2, m: 0 }}
                          />

                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              fontSize: '14px',
                              color: '#1F2937'
                            }}
                          >
                            {league.name}
                          </Typography>
                        </Box>

                        <Avatar
                          src={league.logo}
                          sx={{
                            width: 32,
                            height: 32,
                            mr: 2,
                            backgroundColor: '#F3F4F6'
                          }}
                        >
                          {league.shortName ? league.shortName.charAt(0) : league.name.charAt(0)}
                        </Avatar>

                        {/* Middle Section - Type */}
                        <Box sx={{ flex: 1, textAlign: 'center' }}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: '12px',
                              backgroundColor: league.type === 'API' ? '#EFF6FF' : '#F0FDF4',
                              color: league.type === 'API' ? '#1D4ED8' : '#166534',
                              px: 2,
                              py: 0.5,
                              borderRadius: '12px',
                              display: 'inline-block'
                            }}
                          >
                            {league.type}
                          </Typography>
                        </Box>

                        {/* Right Section - Action Buttons */}
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <IconButton
                            onClick={() => handleEditLeague(league.id)}
                            sx={{
                              color: '#6B7280',
                              '&:hover': { color: '#3C50E0', backgroundColor: '#F3F4F6' },
                              mr: 1
                            }}
                          >
                            <EditIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          <IconButton
                            onClick={() => handleDeleteLeague(league)}
                            sx={{
                              color: '#6B7280',
                              '&:hover': { color: '#EF4444', backgroundColor: '#FEF2F2' }
                            }}
                          >
                            <DeleteIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                ))}

                {getCurrentGameLeagues().length === 0 && (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '200px',
                      border: '2px dashed #E5E7EB',
                      borderRadius: '8px',
                      backgroundColor: '#F9FAFB'
                    }}
                  >
                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
                      No leagues found
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 2 }}>
          <TransButton
            title="Publish"
            onClick={handleSave}
          />
          <TransButton
            title="Cancel"
            onClick={handleCancel}
            sx={{
              background: "none",
              border: "1px solid #1C2434",
              color: "#1C2434",
              '&:hover': {
                background: "none"
              }
            }}
          />
        </DialogActions>
      </Dialog>

      {/* Create New League Modal */}
      <CreateNewLeagueModal
        open={createNewLeagueOpen}
        onClose={handleCreateNewLeagueClose}
        onSave={handleCreateNewLeagueSave}
        selectedGame={getCurrentGameId()}
        gamesData={currentGames}
        onRefreshLeagues={onRefreshLeagues}
      />

      <EditLeagueModal
        open={editLeagueOpen}
        onClose={handleEditLeagueClose}
        onSave={handleEditLeagueSave}
        leagueData={editLeagueData}
        gamesData={currentGames}
        onRefreshLeagues={onRefreshLeagues}
      //onRefreshGames={onRefreshGames}
      />

      <ModalPopUp
        openpopup={deletePopup}
        setPopup={setDeletePopup}
        title={'Confirm Delete'}
        subTitle={deleteMessage}
        onClick={confirmDeleteLeague}
        save={'Delete'}
        cancel={'Cancel'}
        onCancel={cancelDeleteLeague}
      />

    </>
  );
};

export default LeaguesModal;